import React, { useState, useEffect, useContext, useRef } from "react"
import Section from "../sections/section"
import RightSideBar from "../sections/section-right-side-bar"
import { SectionContext } from "../context/sectionContext"
import { PageContext } from "../context/pageContext"
import { JourneyContext } from "../context/journeyContext"
import { LoaderContext } from "../context/loaderContext"
import { ErrorContext } from "../context/errorContext"
import { ConditionContext } from "../context/conditionContext"
import { componentRenderCheck, multiConditionComponentRenderCheck } from "../services/componentRenderCheck"
import { refreshToken } from "../../interceptors/jwt-interceptor"
// import { window, document } from "browser-monads";
import {
  saveApplication,
  saveApplicationDetailsOverall,
  generateBI,
  fetchApplicationDetails,
  getAllInputQuotations,
  saveTransactionDetails,
  getIpAddress,
  getJWTTokenForIp,
  checkPaymentStatus,
  paymentTextDecrypt,
  digilocker,
  saveEnachTransactionDetails,
  updateUserTrackerDetails,
  verifyCaptcha,
  saveBasbaTransactionLogs,
  getConfigByType,
  dedupeCall,
  dedupeCallProposer,
  fetchDetailsAndSetCookie
} from "../../services/apiservice"
import { findCurrentJourneyCode, getKeyFromValueLookup, getValueFromLookup, getValueFromJourney, getLastPageAndLastSection, getAge, isEquitasChannel, mapReceiptEnquiryToPaymentStatus, isPostRFITransaction } from "../services/helperFunctions"
import {
  isFirstPageContactConsentStep,
  isConsentRequiredOnFirstPage,
  validateFirstPageContactConsent,
  CONTACT_CONSENT_CONFIG,
} from "../services/contactConsentPolicy"
import * as callBiKeyJson from "../../../static/callBiKey.json"
import * as freezeJson from "../../../static/freezeDataOnApiCalls.json"
import * as lookup from "../../../static/lookup.json"
import moment from "moment"

//static pages
import ProvideYourConsent from "../sections/provide-your-consent"
import Ekyc from "../sections/ekyc/ekyc"
import EkycProposer from "../sections/ekyc/ekycProposer"
import Ckyc from "../sections/ckyc"
import ProvideYourConsentProposer from "../sections/provide-your-consent-proposer"
import Payment from "../sections/payment"
import UploadDocuments from "../sections/upload-documents"
import SuccessfulTransactions from "../sections/successful-transaction"
import Declaration from "../sections/declaration"
import Submission from "../sections/submission"
import UnsuccessfulTransaction from "../sections/unsuccessful-transaction"
import PendingTransaction from "../sections/pending-transaction"
import PendingTransactionBasba from "../sections/pending-transaction-basba"
import { element } from "prop-types"
import { errorToastr, successToastr, clearToastr } from "../../services/error-handler"
import { success } from "toastr"
import ENachPhysicalMandate from "../sections/Enach-physicalMandate"
import CkycProposer from "../sections/ckycProposer"
import { ConsoleView } from "react-device-detect"
import BIPension4Life from "../sections/pension4Life/biPension4Life"
import ReviewDetailsPension4Life from "../sections/pension4Life/review-details-pension4Life"
import SalesConfidentialReport from "../sections/salesConfidentialReport"
import ThankYou from "../sections/Thank-You"
import BISmartGuaranteedPension from "../sections/smartGuaranteedPension/biSmartGuaranteedPension"
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { setCookiesFromBackend } from "../../shared/functions"

const Page = props => {

  //{local component states}
  // const sections = props.sections;
  const [currentSectionIndex, setCurrentSectionIndex] = useState(0)
  const [showError, setShowError] = useState(false)
  const [nvestFilterResult, setNvestFilterResult] = useState()
  const [saveApplicationCounter, setSaveApplicationCounter] = useState(0)

  //handeling context{context states}
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [journeyState, setJourneyState,isFirstProposalPageCovered2] = useContext(JourneyContext)
  const loaderContext = useContext(LoaderContext)
  const showLoader = loaderContext ? loaderContext[0] : false
  const [errorState, setErrorState, fieldRefs, scrollToFirstError] = useContext(ErrorContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [firstPassForFreezingDataSections, setFirstPassForFreezingDataSections] = useState({
    "SectionPension4lifePrimaryAnnuitantPersonalDetail": true,
    "SectionPension4lifePrimaryAnnuitantCommunicationDetails": true,
    "SectionPension4lifePrimaryAnnuitantOccupationDetails": true,
    "SectionPension4lifeSecondaryAnnuitantPersonalDetail": true,
    "SectionPension4lifeSEcondaryAnnuitantCommunicationDetails": true,
    "SectionPension4lifeSecondaryAnnuitantOccupationDetails": true,
    "SectionPension4LifeProposerPersonalDetail": true,
    "SectionPension4LifeProposerCommunication": true,
    "SectionPension4lifeFillProposalBankDetails": true,
    "sectionPension4LifeSecAnnuitantBankDetails": true,
    "SectionPension4lifeProposerBankDetails": true,
    "SectionPension4LifeProposerOccupation": true,

  })
  const [firstPassForPremiumPaymentBicall, setFirstPassForPremiumPaymentBicall] = useState(true)
  const [firstPageAutoFillApiCall, setFirstPageAutoFillApiCall] = useState(false)
  const [showMainButtonFlexiEdgePlan, setShowMainButtonFlexiEdgePlan] = useState(true)
  const ProductJourneyId = [ 
     "FlexiEdgeJourney",
     "titaniumPlusJourney",
     "alphaWealthPlanJourney",
     "guaranteedSavingsOption",
     "guaranteedIncomeAdvantage",
     "GuarateedOnePayJourney",
     "insureSmart",
     "moneyBackAdvantage",
     "jeevanNivesh",
     "invest4GJourney",
     "secureBhavishyaJourney",
     "smartJuniorPlan",
     "guaranteedFortuneJourney",
     "guaranteedFutureJourney",
     "guaranteedIncome4LifeJourney",
     "GAINjourney"
    ]
  const equitasSkipSections = new Set([
    "ekyc",
    "ckyc",
    "provide-your-consent",
    "ekycProposer",
    "ckycProposer",
    "provide-your-consent-proposer"
  ])

  const biPages = [
    "PageSmartGuaranteedPensionBenefitIllustration"
  ]

  const removeEquitasSectionsFromJourney = (journeySteps, channel) => {
    if (!isEquitasChannel(channel) || !journeySteps?.pages?.length) {
      return
    }
    const benefitIllustrationPageIndex = journeySteps.pages.findIndex(page =>
      biPages.includes(page?.pageId)
    )
    if (benefitIllustrationPageIndex === -1) {
      return
    }
    const benefitIllustrationPage = journeySteps.pages[benefitIllustrationPageIndex]
    if (!benefitIllustrationPage?.sections?.length) {
      return
    }
    benefitIllustrationPage.sections = benefitIllustrationPage.sections.filter(
      section => !equitasSkipSections.has(section.sectionId)
    )
  }

  const getIsLaAndProposerDifferent = () => {
    return journeyState?.journeyData?.[0]?.pageData?.[0]?.sectionData?.GOPAslifetobeAssuredandProposer == "Y";
  }


  const moveComponentGroupToLast = (journeySteps, pageId, sectionId, componentGroupId) => {
    try {
      const pageIndex = journeySteps?.pages?.findIndex(page => page.pageId === pageId)
      if (pageIndex < 0) {
        return
      }

      const sectionIndex = journeySteps.pages[pageIndex]?.sections?.findIndex(
        section => section.sectionId === sectionId
      )
      if (sectionIndex < 0) {
        return
      }

      const componentGroups = journeySteps.pages[pageIndex].sections[sectionIndex].component_groups
      if (!Array.isArray(componentGroups)) {
        return
      }

      const componentGroupIndex = componentGroups.findIndex(
        group => group.componentId === componentGroupId
      )
      if (componentGroupIndex < 0 || componentGroupIndex === componentGroups.length - 1) {
        return
      }

      const [componentGroup] = componentGroups.splice(componentGroupIndex, 1)
      componentGroups.push(componentGroup)
    } catch (err) {
      console.log(err, "=====>Error moving component group to last")
    }
  }

  const [callBi, setCallBi] = useState(false)
  const { executeRecaptcha } = useGoogleReCaptcha();
  const firstPageDedupeTriggeredRef = useRef(false)

  const [fnaHsbcData, setFnaHsbcData] = useState(null)
  // const { executeRecaptcha } = useGoogleReCaptcha();

  const sections = props.sections?.filter(element => {
    if (element.conditions.length === 1) {
      if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey], journeyState)) {
        return element
      }
    } else if (element.conditions.length > 1) {
      if (multiConditionComponentRenderCheck(element.conditions, conditionState, journeyState)) {
        return element
      }
    } else {
      return element
    }
  })
  // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect (()=>{
      let temp = journeyState.journeySteps
      let pageId = ""
      let sectionId = ""
      let contactNumberComponentId = ""
      let contactNumberFormControlKey = ""
      let countryCodeFormControlKey = ""
      let proposerContactNumberComponentId = ""
      let proposerContactNumberFormControlKey = ""
      let proposerCountryCodeFormControlKey = ""

      if (journeyState.journeyIdFromStrapi === "pension4LifeJourney"){
        pageId = "PagePension4lifeCalculateAnnutiyInstallment"
        sectionId = "SectionPension4lifePersonalDetailsofPrimaryAnnuitment"
        contactNumberComponentId = "contactNoPension4life"
        contactNumberFormControlKey = "contactNoPension4life"
        proposerContactNumberComponentId = "proposerDetailsPesnion4life"
        proposerContactNumberFormControlKey = "proposerNumber"
        countryCodeFormControlKey = "CountryCodesPension4life"
        proposerCountryCodeFormControlKey = "proposerCountryCode"
      }else if (journeyState.journeyIdFromStrapi === "smartGuaranteedPensionJourney"){
        pageId = "PageSmartGuaranteedPensionCalculatePremium"
        sectionId = "SectionSmartGuaranteedPensionPersonalDetails"
        contactNumberComponentId = "contactNoPension4life"
        contactNumberFormControlKey = "contactNoPension4life"
        proposerContactNumberComponentId = "GOPAproposerDetails"
        proposerContactNumberFormControlKey = "GOPAnumber"
        countryCodeFormControlKey = "CountryCodesPension4life"
        proposerCountryCodeFormControlKey = "GOPAproposerCode"
      }
 
      if(sectionState?.sectionData?.[countryCodeFormControlKey] != '+91'){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === contactNumberComponentId)
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === contactNumberFormControlKey)
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 7
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
      }
      else if(sectionState?.sectionData?.[countryCodeFormControlKey]== '+91'){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === contactNumberComponentId)
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === contactNumberFormControlKey)
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
      
      }
      
      if(sectionState?.sectionData?.[proposerCountryCodeFormControlKey] !="+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === proposerContactNumberComponentId)
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === proposerContactNumberFormControlKey)
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 7
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
      }
      else if(sectionState?.sectionData?.[proposerCountryCodeFormControlKey] =="+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === proposerContactNumberComponentId)
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === proposerContactNumberFormControlKey)
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10
      }
  
      if(sectionState?.sectionData?.LAalternateMobCountryCode != "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePension4lifeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPension4lifePrimaryAnnuitantCommunicationDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "alternateNumberLA")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "AlternateMobNumber")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 7
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
      }
      else if(sectionState?.sectionData?.LAalternateMobCountryCode == "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePension4lifeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPension4lifePrimaryAnnuitantCommunicationDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "alternateNumberLA")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "AlternateMobNumber")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10
      }

      //permanent address same as temporary address
      if(sectionState?.sectionData?.PDcountryCode != "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePension4lifeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPension4lifePrimaryAnnuitantCommunicationDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "PermanentAddressDetails")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "PDcontactNo")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 7
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
      }
      else if(sectionState?.sectionData?.PDcountryCode == "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePension4lifeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPension4lifePrimaryAnnuitantCommunicationDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "PermanentAddressDetails")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "PDcontactNo")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10
      }
  
  
      ///proposer primary number in communication details
      if (sectionState?.sectionData?.mobileNumber != "+91") {
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePension4lifeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPension4LifeProposerCommunication")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "ProposerMobileWithISDcode")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "contactNo")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 7
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
      }
      else if (sectionState?.sectionData?.mobileNumber == "+91") {
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePension4lifeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPension4LifeProposerCommunication")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "ProposerMobileWithISDcode")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "contactNo")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = "E168"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10
      }

      if(sectionState?.sectionData?.proposerAlternateMobCountryCode != "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePension4lifeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPension4LifeProposerCommunication")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "proposerPensionAlternateNumber")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey ==="AlternateMobNumber")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 7
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
      }
      else if(sectionState?.sectionData?.proposerAlternateMobCountryCode == "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePension4lifeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPension4LifeProposerCommunication")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "proposerPensionAlternateNumber")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey ==="AlternateMobNumber")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = "E168"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10
      }

      //proposer occupation contact
      if(sectionState?.sectionData?.EDcountryCode != "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePension4lifeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPension4LifeProposerOccupation")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "ProposerEmployerDetailsPension4life")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey ==="contactNo")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 7
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
      }
      else if(sectionState?.sectionData?.EDcountryCode == "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePension4lifeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPension4LifeProposerOccupation")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "ProposerEmployerDetailsPension4life")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey ==="contactNo")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = "E168"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10
      }
    
      ///primary annuitant contact number first one in communication details
      if(sectionState?.sectionData?.mobileNumber != "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePension4lifeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPension4lifePrimaryAnnuitantCommunicationDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "mobileWithISDcode")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey ==="contactNo")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 7
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
      }
      else if(sectionState?.sectionData?.mobileNumber == "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePension4lifeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPension4lifePrimaryAnnuitantCommunicationDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "mobileWithISDcode")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey ==="contactNo")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = "E168"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10
      }

      ///primary annuit office contact
      if(sectionState?.sectionData?.EDcountryCode != "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePension4lifeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPension4lifePrimaryAnnuitantOccupationDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "EmployerDetailsPension4life")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey ==="contactNo")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 7
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
      }
      else if(sectionState?.sectionData?.EDcountryCode == "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePension4lifeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPension4lifePrimaryAnnuitantOccupationDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "EmployerDetailsPension4life")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey ==="contactNo")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = "E168"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10
      }
      
      //nominee address contact
      if(sectionState?.sectionData?.nomineePrimaryCountryCode != "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePension4lifeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPension4lifeNomineeCommunicationDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "nomineePrimaryMobileISD")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey ==="contactNoNomineePrimary")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 7
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
      }
      else if(sectionState?.sectionData?.nomineePrimaryCountryCode == "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePension4lifeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPension4lifeNomineeCommunicationDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "nomineePrimaryMobileISD")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey ==="contactNoNomineePrimary")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = "E168"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10
      }

      //nominee address contact2
      if(sectionState?.sectionData?.PDcountryCode != "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePension4lifeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPension4lifeNomineeCommunicationDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "NomineePermanentAddressDetails")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey ==="PDcontactNo")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 7
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
      }
      else if(sectionState?.sectionData?.PDcountryCode == "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePension4lifeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPension4lifeNomineeCommunicationDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "NomineePermanentAddressDetails")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey ==="PDcontactNo")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = "E168"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10
      }

      //appointee communication details contact
      if(sectionState?.sectionData?.mobileNumberCountryCode != "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePension4lifeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPension4lifeAppointeeCommunicationDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "mobileWithISDcodeAppointee")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey ==="contactNo")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 7
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
      }
      else if(sectionState?.sectionData?.mobileNumberCountryCode == "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePension4lifeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPension4lifeAppointeeCommunicationDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "mobileWithISDcodeAppointee")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey ==="contactNo")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = "E168"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10
      }
      
      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: temp
        })
      })
 
  },[sectionState?.sectionData?.["CountryCodesPension4life"],sectionState?.sectionData?.["proposerCountryCode"], sectionState?.sectionData?.["mobileNumber"],  sectionState?.sectionData?.["LAalternateMobCountryCode"] ,sectionState?.sectionData?.["PDcountryCode"], sectionState?.sectionData?.["EDcountryCode"], sectionState?.sectionData?.["annuitantMobileWithISDcode"],sectionState?.sectionData?.["annuitantPDcountryCode"],sectionState?.sectionData?.["nomineePrimaryCountryCode"],sectionState?.sectionData?.["mobileNumberCountryCode"],sectionState?.sectionData?.["proposerAlternateMobCountryCode"]])

  //Code to scroll to top
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    window.scroll(0, 0);
  }, [currentSectionIndex])
  //Code for decryptData
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    //case of redirection from bank source
    if (props.decryptData) {
      setPageState(props.decryptData?.journeyPayload[0])
      setSectionState(prev => {
        return ({
          ...prev,
          sectionId: props.decryptData?.journeyPayload[0].pageData[0].sectionId,
          sectionFirstPass: true,
          sectionData: { ...prev.sectionData, ...props.decryptData?.journeyPayload[0].pageData[0].sectionData }
        })
      })
      if (props.decryptData.rmData) {
        setJourneyState(prev => {
          return ({
            ...prev,
            subChannel: props.decryptData?.subChannel,
            planName: props.decryptData?.planName,
            agentDetails: {
              "rmLedJourneyInd": "01",
              "rmLedFNAInd": "N",
              "hsbcRMName": props.decryptData?.rmData?.FULLNAME,
              "hsbcRMMobileNo": props.decryptData?.rmData?.RMMOBILE,
              "rmLedAgentId": props.decryptData?.rmData?.RMCODE,
              "hsbcRMEmailId": props.decryptData?.rmData?.RMEMAIL,
              "rmName": props.decryptData?.rmData?.FULLNAME,
              "rmContactNo": props.decryptData?.rmData?.RMMOBILE,
              "rmLedAgentBRCode": "",
              "agentBankName": ""
            },
            rmLedJourney: "Y"

          })
        })
      } else if (props.decryptData.fnaData) {
        setJourneyState(prev => {
          return ({
            ...prev,
            fnaData: props.decryptData.fnaData
          })
        })
      } else {
        setJourneyState(prev => {
          return ({
            ...prev,
            subChannel: props.decryptData?.subChannel,
            planName: props.decryptData?.planName
          })
        })
      }


    }
    // const urlParams = new URLSearchParams(window.location.search)
    // let urlPart  =window.location.search.toLowerCase()
    // if(urlPart.includes('hsbc')){
    //   document.body.style.backgroundColor = "#ededed";
    // }
  }, [])

  //Code for redirection from payment page
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    //case of redirection from payment page
    let lastPage
    let status
    if (props.paymentData && props.paymentData.payloadJson) {
      status = props.paymentData.payloadJson.status
      let payloadForSaveTransaction = {
        journeyId: props.paymentData.payloadJson.journeyId,
        ...props.paymentData.decryptData
      }
      console.log(payloadForSaveTransaction, "payloadForSaveTransaction-redirectCase")
      saveTransactionDetails(payloadForSaveTransaction).then((res) => {
        console.log("save transaction details 'res'")
        let payload = {
          _id: props.paymentData.payloadJson.journeyId
        }
        fetchApplicationDetails(payload)
          .then(res => {
            lastPage = res.journeyData.lastPage
            let temp = journeyState.journeySteps

            let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "makePayment")
            let pageShowWithTransactionStatus
            if (status === "Success") {
              pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => { return (element.sectionId !== "unsuccessful-transaction" && element.sectionId !== "pending-transaction"  && element.sectionId !== "pending-transaction-basba") })
            } else if (status === "Pending") {
              pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => { return (element.sectionId !== "unsuccessful-transaction" && element.sectionId !== "successful-transaction" && element.sectionId !== "pending-transaction-basba") })
            } else if (status === "Failed") {
              pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => { return (element.sectionId !== "successful-transaction" && element.sectionId !== "pending-transaction" && element.sectionId !== "pending-transaction-basba") })
            }
            console.log(pageShowWithTransactionStatus, "pageShowWithTransactionStatus")
            temp.pages[tempPageIndexToChange].sections = pageShowWithTransactionStatus

             // Make payment page remove for canaraPos 
          if (props?.resumeJourneyData?.journeyData?.journeyType?.toLowerCase() === "canarapos") {
            const pageIndex = temp.pages.findIndex(page => page.pageId === "makePayment");
            temp.pages[pageIndex].sections = temp.pages[pageIndex].sections.filter(
              section => section.sectionId === "eNach-physicalMandate"
            )          } else {
            // Remove SCR section for normal journey
            if(!isEquitasChannel(res?.journeyData?.basicDetails?.channel) ) {
              const pageIndex = temp.pages.findIndex(page => page.pageId === "uploadDocuments");
              temp.pages[pageIndex].sections = temp.pages[pageIndex].sections.filter(section => section.sectionId !== "salesConfidentialReport");
              } else {
                removeEquitasSectionsFromJourney(temp, res?.journeyData?.basicDetails?.channel)
            }
          }
            /*Helper Function  For RMJourney Freeze State*/
            const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key, value) => {
              try {
                let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
                let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
                let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
                let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
                console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "======>ImpTemp0")
                temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
              } catch (err) {
                console.log(err, "=====>ErrorInPage.js===Line-152")
              }
            }
            let fillProposalPageId
            let firstPageId
            if (journeyState.journeyIdFromStrapi === "pension4LifeJourney") {
              fillProposalPageId = "PagePension4lifeFillProposalForm"
              firstPageId = "PagePension4lifeCalculateAnnutiyInstallment"
            }  else if (journeyState.journeyIdFromStrapi === "smartGuaranteedPensionJourney") {
              fillProposalPageId = "PagePension4lifeFillProposalForm"
              firstPageId = "PageSmartGuaranteedPensionCalculatePremium"
            }
            if (res.journeyData?.agentDetails?.rmLedJourneyInd === "01") {
              changeJourneySteps(firstPageId, "CPPersonalDetailsSection", "contactNo", "contactCountryCode", "disabled", true)

              if (journeyState.journeyIdFromStrapi === "iSelectJourney") {
                changeJourneySteps(firstPageId, "CPResidentAndOccupationDetailSection", "CPResidentAndOccupationDetail", "country", "disabled", true)
                changeJourneySteps(firstPageId, "CPResidentAndOccupationDetailSection", "CPResidentAndOccupationDetail", "state", "lookupKey", "state_RM")
              } else if (journeyState.journeyIdFromStrapi === "ISelect360Journey") {
                changeJourneySteps(firstPageId, "iSelect360CPResidentAndOccupationDetailSection", "iSelect360CPResidentAndOccupationDetail", "country", "disabled", true)
                changeJourneySteps(firstPageId, "iSelect360CPResidentAndOccupationDetailSection", "iSelect360CPResidentAndOccupationDetail", "state", "lookupKey", "state_RM")
              }
              else if (journeyState.journeyIdFromStrapi === "FlexiEdgeJourney") {
                changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "currentCountryofResidence", "currentCountryofResidence", "disabled", true)
                changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "currentState", "state", "lookupKey", "state_RM")
                changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "residentialStatus", "residentialStatus", "disabled", true)
                changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "citizenship", "citizenship", "disabled", true)
                changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "nationality", "nationality", "disabled", true)
                changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "taxResidenceCountry", "taxResidenceCountry", "disabled", true)
                changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "countryOfBirth", "countryOfBirth", "disabled", true)

              }

              changeJourneySteps(fillProposalPageId, "personalDetailsSection", "alternateMobileNo", "AlternateMobCountryCode", "disabled", true)

              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentStatus", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCountryOfBirth", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCitizenship", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialNationality", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialTaxResidentialCountry", "disabled", true)

              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRCountry", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRState", "lookupKey", "state_RM")
            }
            setJourneyState(prev => {
              return ({
                ...prev,
                journeySteps: temp,
                journeyData: res.applicationData,
                journeyId: props.paymentData.payloadJson.journeyId,
                applicationNo: props.paymentData.payloadJson.applicationNumber,
                paymentDecryptData: props.paymentData.decryptData,
                paymentStep: res?.journeyData?.paymentStep,
                premium: res?.journeyData?.premium,
                channel: props.paymentData.payloadJson.source
              })
            })
            props.setCurrentPageIndex(lastPage)
            setCurrentSectionIndex(0)
            setConditionState(prev => {
              return {
                ...prev,
                ...res?.conditionData
              }
            })
            // setFirstPassForFreezingDataSections({
            //   "personalDetailsSection": false,
            //   "residenceDetailsSection": false,
            //   "professionalDetailSection": false
            // })
          })
      })
    }
  }, [props.paymentData])

  //Code for redirection from enach page
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    //case of redirection from enach page
    let lastPage
    let status
    if (props.enachData && props.enachData.enachPayloadJson) {
      status = props.enachData.enachPayloadJson.status
      let payloadForSaveTransaction = {
        journeyId: props.enachData.enachPayloadJson.journeyId,
        ...props.enachData.enachDecryptData
      }
      console.log(payloadForSaveTransaction, "payloadForSaveTransaction-redirectCase")
      saveEnachTransactionDetails(payloadForSaveTransaction).then((res) => {
        console.log("save transaction details 'res'")
        let payload = {
          _id: props.enachData.enachPayloadJson.journeyId
        }
        fetchApplicationDetails(payload)
          .then(res => {
            lastPage = res.journeyData.lastPage
            let temp = journeyState.journeySteps

            let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "makePayment")
            let pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => { return (element.sectionId !== "unsuccessful-transaction" && element.sectionId !== "successful-transaction" && element.sectionId !== "pending-transaction" && element.sectionId !== "pending-transaction-basba") })
            props.setCurrentPageIndex(lastPage)
            setCurrentSectionIndex(1)
            temp.pages[tempPageIndexToChange].sections = pageShowWithTransactionStatus

            // Canara POS Logic Remove SCR section for normal journey
            if(res.journeyData?.journeyType?.toLowerCase() !== "canarapos") {
              if(!isEquitasChannel(res?.journeyData?.basicDetails?.channel) ) {
                const pageIndex = temp.pages.findIndex(page => page.pageId === "uploadDocuments");
                temp.pages[pageIndex].sections = temp.pages[pageIndex].sections.filter(section => section.sectionId !== "salesConfidentialReport");
              } else {
                removeEquitasSectionsFromJourney(temp, res?.journeyData?.basicDetails?.channel)
              }
            }

            /*Helper Function  For RMJourney Freeze State*/
            const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key, value) => {
              try {
                let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
                let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
                let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
                let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
                console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "======>ImpTemp0")
                temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
              } catch (err) {
                console.log(err, "=====>ErrorInPage.js===Line-152")
              }
            }
            let fillProposalPageId
            let firstPageId
            if (journeyState.journeyIdFromStrapi === "pension4LifeJourney") {
              fillProposalPageId = "PagePension4lifeFillProposalForm"
              firstPageId = "PagePension4lifeCalculateAnnutiyInstallment"
            } else if (journeyState.journeyIdFromStrapi === "smartGuaranteedPensionJourney") {
              fillProposalPageId = "PagePension4lifeFillProposalForm"
              firstPageId = "PageSmartGuaranteedPensionCalculatePremium"
            }
            if (firstPageId && fillProposalPageId && res.journeyData?.agentDetails?.rmLedJourneyInd === "01") {
              changeJourneySteps(fillProposalPageId, "personalDetailsSection", "alternateMobileNo", "AlternateMobCountryCode", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentStatus", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCountryOfBirth", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCitizenship", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialNationality", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialTaxResidentialCountry", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRCountry", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRState", "lookupKey", "state_RM")
            }
            setJourneyState(prev => {
              return ({
                ...prev,
                journeySteps: temp,
                journeyData: res.applicationData,
                journeyId: props.enachData.enachPayloadJson.journeyId,
                applicationNo: props.enachData.enachPayloadJson.applicationNumber,
                paymentDecryptData: props.enachData.enachDecryptData,
                paymentStep: res?.journeyData?.paymentStep,
                premium: res?.journeyData?.premium,
                digiLockerOption: props.digilockerdata.digilockerDecryptData.option,
                channel: props.enachData.enachPayloadJson.source
              })
            })
            setConditionState(prev => {
              return {
                ...prev,
                ...res?.conditionData
              }
            })
          })
      })
    }
  }, [props.enachData])

    //case of redirection from digilocker page
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      //case of redirection from digilocker page
      if (props.digilockerdata && props.digilockerdata.digilockerPayloadJson && props.digilockerdata.digilockerDecryptData) {
          let payload = {
            _id: props.digilockerdata.digilockerPayloadJson.journeyId
          }
          fetchApplicationDetails(payload)
            .then(async res => {
              try {
                let data = await digilocker(props.digilockerdata.digilockerDecryptData)
              }
              catch(err){
                console.log(err)
              }finally{
                setJourneyState(prev => {
                  return ({
                    ...prev,
                    journeyData: res.applicationData,
                    journeyId: props.digilockerdata.digilockerPayloadJson.journeyId,
                    applicationNo: props.digilockerdata.digilockerPayloadJson.applicationNumber,
                    paymentStep: res?.journeyData?.paymentStep,
                    premium: res?.journeyData?.premium,
                    channel: props.digilockerdata.digilockerPayloadJson.source
                  })
                })
                props.setCurrentPageIndex(4)
                const temp = journeyState?.journeySteps
                const tempPageIndex = temp?.pages?.findIndex(page => page.pageId === "uploadDocuments")
                const tempSectionIndex = temp?.pages[tempPageIndex]?.sections?.findIndex(section => section.sectionId === "UploadDocuments")
                setCurrentSectionIndex(tempSectionIndex !== -1 ? tempSectionIndex  : 1)
              }
            })
      
      }
    }, [props.digilockerdata])


   //Code for redirection from lien registeration page
   // eslint-disable-next-line react-hooks/rules-of-hooks
   useEffect(() => {
    //case of redirection from enach page
    let lastPage
    let status
    if (props.lienData && props.lienData.lienPayloadJson) {
      status = props.lienData.lienPayloadJson.status?.toLowerCase()
      let payloadForSaveTransaction = {
        journeyId: props.lienData.lienPayloadJson.journeyId,
        ...props.lienData.lienDecryptData
      }
      saveBasbaTransactionLogs(payloadForSaveTransaction).then((res) => {
        console.log("save transaction details 'res'")
        let payload = {
          _id: props.lienData.lienPayloadJson.journeyId
        }
        fetchApplicationDetails(payload)
          .then(res => {
            let temp = journeyState.journeySteps
            lastPage = res.journeyData.lastPage
              // remove scr from normal journey
              let pageIndex = temp.pages.findIndex(page => page.pageId === "uploadDocuments");
              if(pageIndex && pageIndex!==-1){
                if(!isEquitasChannel(res?.journeyData?.basicDetails?.channel) ) {
                  temp.pages[pageIndex].sections = temp.pages[pageIndex].sections.filter(section => section.sectionId !== "salesConfidentialReport");
                  } else {
                    removeEquitasSectionsFromJourney(temp, res?.journeyData?.basicDetails?.channel)
                }
              }
              let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "makePayment")
              let pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => { return (element.sectionId !== "unsuccessful-transaction" && element.sectionId !== "successful-transaction" && element.sectionId !== "pending-transaction") }) || [];
              let tempSectionIndex=pageShowWithTransactionStatus.findIndex(section=>section.sectionId==="pending-transaction-basba")//pending-transaction-basba 
              temp.pages[tempPageIndexToChange].sections = pageShowWithTransactionStatus

            /*Helper Function  For RMJourney Freeze State*/
            const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key, value) => {
              try {
                let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
                let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
                let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
                let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
                console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "======>ImpTemp0")
                temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
              } catch (err) {
                console.log(err, "=====>ErrorInPage.js===Line-152")
              }
            }
            let fillProposalPageId
            let firstPageId
            if (journeyState.journeyIdFromStrapi === "pension4LifeJourney") {
              fillProposalPageId = "PagePension4lifeFillProposalForm"
              firstPageId = "PagePension4lifeCalculateAnnutiyInstallment"
            } else if (journeyState.journeyIdFromStrapi === "smartGuaranteedPensionJourney") {
              fillProposalPageId = "PagePension4lifeFillProposalForm"
              firstPageId = "PageSmartGuaranteedPensionCalculatePremium"
            }
            if (firstPageId && fillProposalPageId && res.journeyData?.agentDetails?.rmLedJourneyInd === "01") {
              changeJourneySteps(fillProposalPageId, "personalDetailsSection", "alternateMobileNo", "AlternateMobCountryCode", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentStatus", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCountryOfBirth", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCitizenship", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialNationality", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialTaxResidentialCountry", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRCountry", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRState", "lookupKey", "state_RM")
            }
            setJourneyState(prev => {
              return ({
                ...prev,
                journeySteps: temp,
                journeyData: res.applicationData,
                journeyId: props.lienData.lienPayloadJson.journeyId,
                applicationNo: props.lienData.lienPayloadJson.applicationNumber,
                paymentDecryptData: props.lienData.enachDecryptData,
                paymentStep: res?.journeyData?.paymentStep,
                premium: res?.journeyData?.premium,
                channel: props.lienData.lienPayloadJson.source,
                premiumOption: res?.journeyData?.basicDetails?.premiumOption,
                lastPage: lastPage,
                lastSection: res?.journeyData?.lastSection,
                lienStatus: true
              })
            })
            setConditionState(prev => {
              return {
                ...prev,
                ...res?.conditionData
              }
            })
            props.setCurrentPageIndex(lastPage)
            if (tempSectionIndex !== null) {
              setCurrentSectionIndex(tempSectionIndex)
            }
          })
      })
    }
  }, [props.lienData])


  const applyDisabledFieldsFromResume = (temp2) => {
    let temp = temp2 || journeyState.journeySteps
    const disabledFields = props?.resumeJourneyData?.applicationData?.disabledFields
    if (!Array.isArray(disabledFields) || disabledFields.length === 0) {
      return
    }

    disabledFields.forEach((pageConfig) => {
      const pageId = pageConfig?.pageId
      if (!pageId) {
        return
      }

      const pageIndex = temp.pages.findIndex((page) => page.pageId === pageId)
      if (pageIndex < 0) {
        return
      }

      pageConfig?.pageData?.forEach((sectionConfig) => {
        const sectionId = sectionConfig?.sectionId
        if (!sectionId) {
          return
        }

        const sectionIndex = temp.pages[pageIndex]?.sections?.findIndex(
          (section) => section.sectionId === sectionId
        )
        if (sectionIndex < 0) {
          return
        }

        const sectionData = sectionConfig?.sectionData
        if (!sectionData || typeof sectionData !== "object") {
          return
        }

        Object.entries(sectionData).forEach(([formControlKey, isDisabled]) => {
          if (isDisabled !== true) {
            return
          }

          const componentGroups = temp.pages[pageIndex]?.sections?.[sectionIndex]?.component_groups
          if (!Array.isArray(componentGroups)) {
            return
          }

          for (let groupIndex = 0; groupIndex < componentGroups.length; groupIndex++) {
            const components = componentGroups[groupIndex]?.components
            if (!Array.isArray(components)) {
              continue
            }

            const componentIndex = components.findIndex(
              (component) => component?.formControlKey === formControlKey
            )
            if (componentIndex > -1) {
              components[componentIndex].disabled = true
              break
            }
          }
        })
      })
    })
  }

  // Equitas: apply disabled fields from resume when sectionState changes
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if(isEquitasChannel(journeyState.channel) && props?.resumeJourneyData?.applicationData?.disabledFields){
      applyDisabledFieldsFromResume()
    }
  }, [sectionState])

  //Code for resume journey
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (props.resumeJourneyData && !journeyState.journeyId) {
       // journey resumed
    try {
      const payload = {
        journeyId: journeyState.journeyId, 
        buttonClicked:  "Resume journey", 
      };
      updateUserTrackerDetails(payload)
        .then((response) => {
          if (response?.status) {
            console.log("UserTracker updated successfully:", response.message);
          } else {
            console.error("Error in updating UserTracker:", response?.message);
          }
        })
        .catch((error) => {
          console.error("Error in updateUserTrackerDetails API call:", error);
        })
    } catch (error) {
      console.error("Error in resumeJourney", error);
    }

      let lastTransaction = props?.resumeJourneyData?.applicationData?.journeyData?.transactionDetails
      let srcTraceId = props?.resumeJourneyData?.applicationData?.journeyData?.transactionDetails?.srcTraceId ?? ''
      let paymentStatus = props?.resumeJourneyData?.applicationData?.journeyData?.transactionDetails?.paymentStatus ?? ''

      console.log("lastTransaction", lastTransaction)

      const resumeJourneyCall = (paymentStatus) => {
        if (props.resumeJourneyData.journeyData.lastPage !== props.currentPageIndex) {
          props.setCurrentPageIndex(props.resumeJourneyData.journeyData.lastPage)
        }
        setErrorState({})
        setCurrentSectionIndex(props.resumeJourneyData.journeyData.lastSection)

        if (journeyState.journeyId !== props.resumeJourneyData.journeyData._id) {
          let temp = journeyState.journeySteps

          // handling-pending-payment
          let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "makePayment")
          let pageShowWithTransactionStatus
          if(props.resumeJourneyData.journeyData?.isBasbaAttempted==="Y"){
            pageShowWithTransactionStatus=temp.pages[tempPageIndexToChange].sections.filter(element => { return (element.sectionId !== "unsuccessful-transaction" && element.sectionId !== "pending-transaction" && element.sectionId !== "successful-transaction") })
            temp.pages[tempPageIndexToChange].sections = pageShowWithTransactionStatus
          }
          else{
            // handling-pending-payment
            if (paymentStatus === "Success") {
              pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => { return (element.sectionId !== "unsuccessful-transaction" && element.sectionId !== "pending-transaction") })
              temp.pages[tempPageIndexToChange].sections = pageShowWithTransactionStatus
            } else if (paymentStatus === "Pending") {
              pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => { return (element.sectionId !== "unsuccessful-transaction" && element.sectionId !== "successful-transaction") })
              temp.pages[tempPageIndexToChange].sections = pageShowWithTransactionStatus
            } else if (paymentStatus === "Failed") {
              pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => { return (element.sectionId !== "successful-transaction" && element.sectionId !== "pending-transaction") })
              temp.pages[tempPageIndexToChange].sections = pageShowWithTransactionStatus
            }
          }

          console.log("pageWithoutUnsuccessfulTransaction", pageShowWithTransactionStatus)

          // Make payment page remove for canaraPos 
          let sendCaseToCustomerFirstResume
          if(props?.resumeJourneyData?.journeyData?.journeyType?.toLowerCase() === "canarapos" && props?.resumeJourneyData?.journeyData?.canaraPosCaseType === "sendLinktosales"){
            if(props?.resumeJourneyData?.journeyData?.scrFirstPass){
              temp.pages = temp.pages.filter(page => page.pageId !== "makePayment")
              const pageIndex = temp.pages.findIndex(page => page.pageId === "uploadDocuments");
              temp.pages[pageIndex].sections = temp.pages[pageIndex].sections.filter(section => section.sectionId !== "salesConfidentialReport");
              if(props?.resumeJourneyData?.journeyData?.sendCaseToCustomerFirstResume === true){
                props.setCurrentPageIndex(2)
                setCurrentSectionIndex(0)
                sendCaseToCustomerFirstResume = false
              }
            }else{
              temp.pages = temp.pages.filter(page => page.pageId !== "PagePension4lifeFillProposalForm" && page.pageId !== "makePayment" && page.pageId !== "uploadDocuments")
              temp.pages.push(...lookup.sendLinktosales)
              if(props?.resumeJourneyData?.journeyData?.productDetails?.premiumFrequency === "SG"){
                temp.pages = temp.pages.filter(page => page.pageId !== "makePayment")
              }
            }
          }else 
          if (props?.resumeJourneyData?.journeyData?.journeyType?.toLowerCase() === "canarapos" && props?.resumeJourneyData?.journeyData?.productDetails?.premiumFrequency === "SG") {
            temp.pages = temp.pages.filter(
              page => page.pageId !== "makePayment"
            )
          }else if (props?.resumeJourneyData?.journeyData?.journeyType?.toLowerCase() === "canarapos") {
        const pageIndex = temp.pages.findIndex(page => page.pageId === "makePayment");
        temp.pages[pageIndex].sections = temp.pages[pageIndex].sections.filter(
          section => section.sectionId === "eNach-physicalMandate"
        )}else{
         // Remove SCR section for normal journey.
         const channel = props?.resumeJourneyData?.journeyData?.basicDetails?.channel;
         if (!isEquitasChannel(channel)) {
          const pageIndex = temp.pages.findIndex(page => page.pageId === "uploadDocuments");
          temp.pages[pageIndex].sections = temp.pages[pageIndex].sections.filter(section => section.sectionId !== "salesConfidentialReport");
            } else {
              removeEquitasSectionsFromJourney(temp, channel)
         }
      }

        if(props?.resumeJourneyData?.applicationData?.journeyData?.skippaymentcase){
          const pageIndex = temp.pages.findIndex(page => page.pageId === "makePayment");
          let makePaymentPageSections = temp.pages[pageIndex].sections;
          makePaymentPageSections = makePaymentPageSections.filter(section => section.sectionId === "eNach-physicalMandate");
          temp.pages[pageIndex].sections = makePaymentPageSections;
        }

          /*Helper Function  For RMJourney Freeze State*/
          const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key, value) => {
            try {
              let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
              let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
              let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
              let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
              console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "======>ImpTemp0")
              temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
            } catch (err) {
              console.log(err, "=====>ErrorInPage.js===Line-152")
            }
          }

 
          let fillProposalPageId
          let firstPageId
          let sectionId
          if (journeyState.journeyIdFromStrapi === "pension4LifeJourney") {
            fillProposalPageId = "PagePension4lifeFillProposalForm"
            firstPageId = "PagePension4lifeCalculateAnnutiyInstallment"
            sectionId = "SectionPension4lifePersonalDetailsofPrimaryAnnuitment"
          } else if (journeyState.journeyIdFromStrapi === "smartGuaranteedPensionJourney") {
            fillProposalPageId = "PagePension4lifeFillProposalForm"
            firstPageId = "PageSmartGuaranteedPensionCalculatePremium"
            sectionId = "SectionSmartGuaranteedPensionPersonalDetails"
          }
          if (props?.resumeJourneyData?.applicationData?.journeyData?.agentDetails?.rmLedJourneyInd === "01") {
            changeJourneySteps(firstPageId, "CPPersonalDetailsSection", "contactNo", "contactCountryCode", "disabled", true)

            if (journeyState.journeyIdFromStrapi === "iSelectJourney") {
              changeJourneySteps(firstPageId, "CPResidentAndOccupationDetailSection", "CPResidentAndOccupationDetail", "country", "disabled", true)
              changeJourneySteps(firstPageId, "CPResidentAndOccupationDetailSection", "CPResidentAndOccupationDetail", "state", "lookupKey", "state_RM")
            } else if (journeyState.journeyIdFromStrapi === "ISelect360Journey") {
              changeJourneySteps(firstPageId, "iSelect360CPResidentAndOccupationDetailSection", "iSelect360CPResidentAndOccupationDetail", "country", "disabled", true)
              changeJourneySteps(firstPageId, "iSelect360CPResidentAndOccupationDetailSection", "iSelect360CPResidentAndOccupationDetail", "state", "lookupKey", "state_RM")
              changeJourneySteps(firstPageId, "iSelect360CPResidentAndOccupationDetailSection", "iSelect360CPResidentAndOccupationDetail", "residentStatus", "disabled", true)
              // For Spouse
              changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "spouseMobile-No-order-5", "countryCode", "disabled", true)
              changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "residenceCountry-order-17", "reisdentialCountry", "disabled", true)
              changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "residentStatus-order-18", "residentStatus", "disabled", true)
              changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "nationality-order-19", "residentialNationality", "disabled", true)
              changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "countryOfBirth-order-20", "residentialCountryOfBirth", "disabled", true)
            }
            else if (journeyState.journeyIdFromStrapi === "FlexiEdgeJourney") {
              changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "currentCountryofResidence", "currentCountryofResidence", "disabled", true)
              changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "currentState", "state", "lookupKey", "state_RM")
              changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "residentialStatus", "residentialStatus", "disabled", true)
              changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "citizenship", "citizenship", "disabled", true)
              changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "nationality", "nationality", "disabled", true)
              changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "taxResidenceCountry", "taxResidenceCountry", "disabled", true)
              changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "countryOfBirth", "countryOfBirth", "disabled", true)

            }

            changeJourneySteps(fillProposalPageId, "personalDetailsSection", "alternateMobileNo", "AlternateMobCountryCode", "disabled", true)

            changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentStatus", "disabled", true)
            changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCountryOfBirth", "disabled", true)
            changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCitizenship", "disabled", true)
            changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialNationality", "disabled", true)
            changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialTaxResidentialCountry", "disabled", true)

            changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRCountry", "disabled", true)
            changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRState", "lookupKey", "state_RM")
          }
          // changeJourneySteps("PageFlexiEdgeCalculatePremium", "SectionFlexiEdgeCalculatePremiumPersonalDetails", "privacypolicy-MD-12-order-21", "privacyPolicy", "display", false)
          // changeJourneySteps(firstPageId, "CPPersonalDetailsSection", "privacypolicy-MD-12-order-25", "privacyPolicy", "display", false)
          // console.log(props?.resumeJourneyData?.journeyData?.lastSection === 0 && props?.resumeJourneyData?.journeyData?.lastPage === 0 && props?.resumeJourneyData?.journeyData?.lastPage === 0 && props?.resumeJourneyData?.journeyData?.basicDetails?.applicationNumber);
          const isPensionJourney = ["pension4LifeJourney", "smartGuaranteedPensionJourney"].includes(
            journeyState.journeyIdFromStrapi
          )
          const privacyPolicyGroupId = isPensionJourney
            ? CONTACT_CONSENT_CONFIG.keys.privacyPolicy
            : "privacypolicy-MD-12-order-21"
          const privacyPolicyFormKey = isPensionJourney
            ? CONTACT_CONSENT_CONFIG.keys.privacyPolicy
            : "privacyPolicy"

          if (props?.resumeJourneyData?.journeyData?.lastSection === 0 && props?.resumeJourneyData?.journeyData?.lastPage === 0 && props?.resumeJourneyData?.journeyData?.lastPage === 0 && props?.resumeJourneyData?.journeyData?.basicDetails?.applicationNumber) {
            changeJourneySteps(firstPageId, sectionId, privacyPolicyGroupId, privacyPolicyFormKey, "display", true)
            moveComponentGroupToLast(temp, firstPageId, sectionId, privacyPolicyGroupId)
          } else {
            changeJourneySteps(firstPageId, sectionId, privacyPolicyGroupId, privacyPolicyFormKey, "display", false)
          }
          // if channel is equitas then disable the fields
          if (isEquitasChannel(props?.resumeJourneyData?.journeyData?.basicDetails?.channel)) {
            applyDisabledFieldsFromResume(temp)
          }
          let paymentDecryptData = {
            ...props?.resumeJourneyData?.applicationData?.journeyData?.transactionDetails?.transactions[props?.resumeJourneyData?.applicationData?.journeyData?.transactionDetails?.transactions?.length - 1]
          }
          console.log(paymentDecryptData, "fdgijgigfggh")
          setJourneyState(prev => {
            // console.log("journey state")
            return {
              ...prev,
              journeyId: props?.resumeJourneyData?.journeyData?._id,
              applicationNo:
                props?.resumeJourneyData?.journeyData?.basicDetails
                  ?.applicationNumber,
              illustrationNumber:
                props?.resumeJourneyData?.journeyData?.basicDetails
                  ?.illustrationNumber,
              proposalEntryId:
                props?.resumeJourneyData?.journeyData?.basicDetails?.proposalEntryId,
              journeyData:
                props?.resumeJourneyData?.applicationData?.applicationData,
              premium: props?.resumeJourneyData?.applicationData?.journeyData?.premium,
              paymentDecryptData: paymentDecryptData,
              proposalFormLink: props?.resumeJourneyData?.applicationData?.journeyData?.proposalFormLink,
              paymentStep: props?.resumeJourneyData?.applicationData?.journeyData?.paymentStep,
              journeySteps: temp,
              residenceDetailEmailTrigger: props?.resumeJourneyData?.applicationData?.journeyData?.residenceDetailEmailTrigger === "true" ? true : false,
              channel: props?.resumeJourneyData?.applicationData?.journeyData?.basicDetails?.channel,
              paymentFrequency: props?.resumeJourneyData?.journeyData?.paymentFrequency ? props?.resumeJourneyData?.journeyData?.paymentFrequency : journeyState?.paymentFrequency,
              gstWaiverInd: props?.resumeJourneyData?.applicationData?.journeyData?.productDetails?.gstWaiverInd ?? "N",
              // channel: getKeyFromValueLookup("reverseChannelType", props?.resumeJourneyData?.applicationData?.journeyData?.basicDetails?.channel)?.toLowerCase()
              sendCaseToCustomerFirstResume: sendCaseToCustomerFirstResume
            }
          })
          if (!(props.resumeJourneyData.journeyData.lastPage === 0 && props.resumeJourneyData.journeyData.lastSection === 0)) {
            if (callBi === false) {
              setCallBi(true)
            }
          }
          console.log(props.resumeJourneyData, "fffdf")
          setConditionState({
            ...props?.resumeJourneyData?.applicationData?.conditionData
          })
        }
        let foundPageState = props.resumeJourneyData.applicationData.applicationData.filter(
          element =>
            element.pageId ===
            props.pages[props.resumeJourneyData.journeyData.lastPage].pageId
        )
        // console.log(foundPageState, "found page")
        // console.log(foundPageState[0].pageId, pageState, "page check")
        if (foundPageState[0] && foundPageState[0].pageId !== pageState.pageId) {
          setPageState(prev => {
            // console.log("page state")
            return {
              ...prev,
              pageId: foundPageState[0].pageId,
              pageData: foundPageState[0].pageData,
            }
          })
        }
        // setSectionState({
        //   sectionId: null,
        //   sectionData: {},
        // })
        let eligibleSections = props.pages[props.resumeJourneyData.journeyData.lastPage].sections?.filter(element => {
          if (element.conditions.length === 1) {
            if (componentRenderCheck(element.conditions[0], props?.resumeJourneyData?.applicationData?.conditionData[element.conditions[0].watchKey], journeyState)) {
              return element
            }
          } else if (element.conditions.length > 1) {
            if (multiConditionComponentRenderCheck(element.conditions, props?.resumeJourneyData?.applicationData?.conditionData, journeyState)) {
              return element
            }
          } else {
            return element
          }
        })
        console.log("dsjhfhfd=========>", eligibleSections[
          props.resumeJourneyData.journeyData.lastSection
        ].sectionId)
        let foundSectionState = foundPageState[0]?.pageData.filter(element => {
          if (
            element.sectionId === eligibleSections[props.resumeJourneyData.journeyData.lastSection].sectionId
          ) {
            return element
          }
        })
        // console.log(foundSectionState, "found section")

        if (
          foundSectionState && foundPageState[0] &&
          foundSectionState[0]?.sectionId !== sectionState.sectionId
        ) {
          setSectionState(prev => {
            // console.log("section state")
            return {
              ...prev,
              sectionId: foundSectionState[0]?.sectionId,
              sectionFirstPass: true,
              sectionData: foundSectionState[0]?.sectionData,
            }
          })
        }
        if (!(props.resumeJourneyData.journeyData.lastPage === 0 && props.resumeJourneyData.journeyData.lastSection === 0)) {
          props.setShowFirstSectionFields(true)
        }
        setFirstPageAutoFillApiCall(true)
      }
      if (paymentStatus === 'Pending' || paymentStatus === 'Aborted') {
        checkPaymentStatus(srcTraceId).then((res_str) => {
          const payload = {
            "encryptedtext": res_str
          }
          try {
            if(paymentStatus === "Aborted" && !res_str){
              resumeJourneyCall(paymentStatus)
              return
            }
            paymentTextDecrypt(payload).then(res => {
              console.log(res, "paymentTextDecrypt")
              const newPaymentStatus = res.data.status || paymentStatus
              let newTransactionToBeSaved = lastTransaction.transactions[lastTransaction.transactions?.length - 1]
              newTransactionToBeSaved.status = newPaymentStatus;
              let payloadForSaveTransaction = {
                journeyId: props.resumeJourneyData.journeyData._id,
                ...newTransactionToBeSaved
              }
              console.log(payloadForSaveTransaction, "payloadForSaveTransaction")
              saveTransactionDetails(payloadForSaveTransaction).then((res) => {
                console.log(res, "saveTransactionDetails")
                resumeJourneyCall(newPaymentStatus)
              })
            })
          } catch (err) {
            console.log("error in fields", err)
            resumeJourneyCall(paymentStatus)
          }

        }).catch((err) => {
          console.log("abortedTransactionWith-NoPayment-RedirectToPaymentPage", props.resumeJourneyData.journeyData)
          resumeJourneyCall(paymentStatus);
        })
      } else {
        resumeJourneyCall(paymentStatus);
      }
    }
  }, [props.resumeJourneyData])

  //code for redirection from fna page
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    console.log("Helloo");
    console.log(sectionState);
    console.log(journeyState);
    let pageId = journeyState?.journeySteps?.pages?.[0]?.pageId
    let sectionId = journeyState?.journeySteps?.pages?.[0]?.sections?.[0]?.sectionId
    let fullname = fullNameConverter(props?.fnaData?.fnaData?.fnaData?.fnaDetails?.firstName, props?.fnaData?.fnaData?.fnaData?.fnaDetails?.middleName, props?.fnaData?.fnaData?.fnaData?.fnaDetails?.lastName)
    if(props.fnaData){
      let fnaData = props?.fnaData?.fnaData?.fnaData?.fnaDetails
      let fullname = fullNameConverter(fnaData?.firstName, fnaData?.middleName, fnaData?.lastName)
      console.log(fullname)
      setJourneyState(prev => {
        return({
          ...prev,
          channel: "A", //By-default channel is A (HSBC) in future we have to make it dynamic
          journeyType: "HSBC", 
          hsbcJourneyID: props?.fnaData?.fnaData?.hsbcJourneyID,
          hsbcCustomerNumber: props?.fnaData?.fnaData?.fnaData?.fnaDetails?.hsbc_data?.hsbcCustomerNumber,
          fnaData : {
            PROPOSERFULLNAME: fullname,
            BIRTHDATE: (moment.unix(props?.fnaData?.fnaData?.fnaData?.fnaDetails?.birthDate).utcOffset("+05:30").format("YYYY-MM-DD")) ,
            PHONENUMBER: props?.fnaData?.fnaData?.fnaData?.fnaDetails?.phoneNumber ,
            EMAILID: props?.fnaData?.fnaData?.fnaData?.fnaDetails?.emailId ,
            ANNUALINCOME: props?.fnaData?.fnaData?.fnaData?.fnaDetails?.annualIncome ,
            ANNUALEXPENSES: props?.fnaData?.fnaData?.fnaData?.fnaDetails?.annualExpenses ,
            ANNUALDISPOSABLRINCOME: props?.fnaData?.fnaData?.fnaData?.fnaDetails?.annualDisposableIncome ,
            EXISTINGLIFECOVER: props?.fnaData?.fnaData?.fnaData?.fnaDetails?.existingLifecover ,
            LIFECOVERREQUIRED: props?.fnaData?.fnaData?.fnaData?.fnaDetails?.lifeCoverRequired ,
            GOALTOACHIEVE: props?.fnaData?.fnaData?.fnaData?.fnaDetails?.goalToAchieve ,
            TIMEHORIZON: props?.fnaData?.fnaData?.fnaData?.fnaDetails?.timeHorizon ,
            CAPITALPROTECTION: props?.fnaData?.fnaData?.fnaData?.fnaDetails?.capitalProtection ,
            PREFERREDPLAN: props?.fnaData?.fnaData?.fnaData?.fnaDetails?.preferredPlan
          }
        })
      })
      setErrorState({})
      if(journeyState.journeyIdFromStrapi === "pension4LifeJourney"){
        setSectionState(prev => {
          return {
            ...prev,
            sectionFirstPass: true,
            sectionData: {
              ...prev.sectionData,
              "namePension4life": fullname,
              "emailPension4life": props.fnaData.fnaData.fnaData.fnaDetails.emailId,
              "contactNoPension4life": props.fnaData.fnaData.fnaData.fnaDetails.phoneNumber,
              "CountryCodesPension4life": props.fnaData.fnaData.fnaData.fnaDetails.countryCode,
              // "GOPAannualIncome": props.fnaData.fnaData.fnaData.fnaDetails.annualIncome,
              "DOBPension4life": props.fnaData.fnaData.fnaData.fnaDetails.birthDate
            }
          }
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${pageId}.${sectionId}.namePension4life`]: fullname,
            [`${pageId}.${sectionId}.emailPension4life`]: props.fnaData.fnaData.fnaData.fnaDetails.emailId,
            [`${pageId}.${sectionId}.contactNoPension4life`]: props.fnaData.fnaData.fnaData.fnaDetails.phoneNumber,
            [`${pageId}.${sectionId}.CountryCodesPension4life`]: props.fnaData.fnaData.fnaData.fnaDetails.countryCode,
            [`${pageId}.${sectionId}.DOBPension4life`]: props.fnaData.fnaData.fnaData.fnaDetails.birthDate
          }
        })
      } else if(journeyState.journeyIdFromStrapi === "smartGuaranteedPensionJourney"){
        setSectionState(prev => {
          return {
            ...prev,
            sectionFirstPass: true,
            sectionData: {
              ...prev.sectionData,
              "namePension4life": fullname,
              "emailPension4life": props.fnaData.fnaData.fnaData.fnaDetails.emailId,
              "contactNoPension4life": props.fnaData.fnaData.fnaData.fnaDetails.phoneNumber,
              "CountryCodesPension4life": props.fnaData.fnaData.fnaData.fnaDetails.countryCode,
              "GOPAannualIncome": props.fnaData.fnaData.fnaData.fnaDetails.annualIncome,
              "smartGuaranteedPensionDOB": props.fnaData.fnaData.fnaData.fnaDetails.birthDate
            }
          }
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${pageId}.${sectionId}.namePension4life`]: fullname,
            [`${pageId}.${sectionId}.emailPension4life`]: props.fnaData.fnaData.fnaData.fnaDetails.emailId,
            [`${pageId}.${sectionId}.contactNoPension4life`]: props.fnaData.fnaData.fnaData.fnaDetails.phoneNumber,
            [`${pageId}.${sectionId}.CountryCodesPension4life`]: props.fnaData.fnaData.fnaData.fnaDetails.countryCode,
            [`${pageId}.${sectionId}.smartGuaranteedPensionDOB`]: props.fnaData.fnaData.fnaData.fnaDetails.birthDate,
            [`${pageId}.${sectionId}.GOPAannualIncome`]: props.fnaData.fnaData.fnaData.fnaDetails.annualIncome
          }
        })
      }
    }
  },[props.fnaData])

  // code to autofill data of hsbc_data if comming from fna data

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(()=>{
    if(props.fnaData?.fnaData?.fnaData?.fnaDetails?.hsbc_data){
      setFnaHsbcData(props.fnaData?.fnaData?.fnaData?.fnaDetails?.hsbc_data)
      props.setHsbcData(props.fnaData?.fnaData?.fnaData?.fnaDetails?.hsbc_data)
    }
  },[props.fnaData])

    //code for redirection from canara pos to fna 
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      let data = props?.canaraPosData?.canaraPosData[0]?.fnaData?.fnaDetails
      let pageId = journeyState?.journeySteps?.pages?.[0]?.pageId
      let sectionId = journeyState?.journeySteps?.pages?.[0]?.sections?.[0]?.sectionId
      if(!data){
        return
      }
      let fullname = fullNameConverter(data?.firstName, data?.middleName, data?.lastName)
      console.log(fullname)
      console.log(data);
      setJourneyState(prev => {
        return({
          ...prev,
          channel: "C", //By-default channel is C (CANARA) in future we have to make it dynamic,
          journeyType: "CanaraPos",
          fnaData : {
            PROPOSERFULLNAME: fullname,
            BIRTHDATE: (moment.unix(data?.birthDate).utcOffset("+05:30").format("YYYY-MM-DD")) ,
            PHONENUMBER: data?.phoneNumber ,
            EMAILID: data?.emailId ,
            ANNUALINCOME: data?.annualIncome ,
            ANNUALEXPENSES: data?.annualExpenses ,
            ANNUALDISPOSABLRINCOME: data?.annualDisposableIncome ,
            EXISTINGLIFECOVER: data?.existingLifecover ,
            LIFECOVERREQUIRED: data?.lifeCoverRequired ,
            GOALTOACHIEVE: data?.goalToAchieve ,
            TIMEHORIZON: data?.timeHorizon ,
            CAPITALPROTECTION: data?.capitalProtection ,
            PREFERREDPLAN: data?.preferredPlan
          }
        })
      })
      // setErrorState({})
      console.log(props);
      let temp = journeyState.journeySteps
      if(data?.buyingFor === "self") {
        if(journeyState.journeyIdFromStrapi === "pension4LifeJourney"){
          setSectionState(prev => {
            return {
              ...prev,
              sectionFirstPass: true,
              sectionData: {
                ...prev.sectionData,
                "namePension4life": fullname,
                "emailPension4life": data?.emailId,
                "contactNoPension4life": data?.phoneNumber,
                "CountryCodesPension4life": data?.countryCode,
                // "GOPAannualIncome": data?.annualIncome,
                "DOBPension4life": data?.birthDate,
                "annualIncome": data?.annualIncome,
                "genderPension4life": lookup?.fnaGender?.[0][data.title]
              }
            }
          })
          setConditionState(prev => {
            return {
              ...prev,
              [`${pageId}.${sectionId}.namePension4life`]: fullname,
              [`${pageId}.${sectionId}.emailPension4life`]: data?.emailId,
              [`${pageId}.${sectionId}.contactNoPension4life`]: data?.phoneNumber,
              [`${pageId}.${sectionId}.CountryCodesPension4life`]: data?.countryCode,
              [`${pageId}.${sectionId}.DOBPension4life`]: data?.birthDate,
              [`${pageId}.${sectionId}.genderPension4life`]: lookup?.fnaGender?.[0][data.title]
            }
          })
          let componentNameFreeze = temp.pages[0].sections[0].component_groups.findIndex(element => element.componentId === "namePension4life")
          let componentEmailFreeze = temp.pages[0].sections[0].component_groups.findIndex(element => element.componentId === "emailPension4life")
          let componentNumberFreeze = temp.pages[0].sections[0].component_groups.findIndex(element => element.componentId === "contactNoPension4life")
          let componentLifeToBeAssuredAndFreeze = temp.pages[0].sections[0].component_groups.findIndex(element => element.componentId === "lifeToBeAssuredPension4LIfe")
          temp.pages[0].sections[0].component_groups[componentNameFreeze].components[0]["disabled"] = true
          temp.pages[0].sections[0].component_groups[componentEmailFreeze].components[0]["disabled"] = true
          // temp.pages[0].sections[0].component_groups[componentNumberFreeze].components[1]["disabled"] = true
          temp.pages[0].sections[0].component_groups[componentLifeToBeAssuredAndFreeze].components[0]["disabled"] = true
        } else if(journeyState.journeyIdFromStrapi === "smartGuaranteedPensionJourney"){
          setSectionState(prev => {
            return {
              ...prev,
              sectionFirstPass: true,
              sectionData: {
                ...prev.sectionData,
                "namePension4life": fullname,
                "emailPension4life": data?.emailId,
                "contactNoPension4life": data?.phoneNumber,
                "CountryCodesPension4life": data?.countryCode,
                "GOPAannualIncome": data?.annualIncome,
                "smartGuaranteedPensionDOB": data?.birthDate,
                "genderPension4life": lookup?.fnaGender?.[0][data.title]
              }
            }
          })
          setConditionState(prev => {
            return {
              ...prev,
              [`${pageId}.${sectionId}.namePension4life`]: fullname,
              [`${pageId}.${sectionId}.emailPension4life`]: data?.emailId,
              [`${pageId}.${sectionId}.contactNoPension4life`]: data?.phoneNumber,
              [`${pageId}.${sectionId}.CountryCodesPension4life`]: data?.countryCode,
              [`${pageId}.${sectionId}.smartGuaranteedPensionDOB`]: data?.birthDate,
              [`${pageId}.${sectionId}.genderPension4life`]: lookup?.fnaGender?.[0][data.title]
            }
          })
          let componentNameFreeze = temp.pages[0].sections[0].component_groups.findIndex(element => element.componentId === "namePension4life")
          let componentEmailFreeze = temp.pages[0].sections[0].component_groups.findIndex(element => element.componentId === "emailPension4life")
          let componentNumberFreeze = temp.pages[0].sections[0].component_groups.findIndex(element => element.componentId === "contactNoPension4life")
          let componentLifeToBeAssuredAndFreeze = temp.pages[0].sections[0].component_groups.findIndex(element => element.componentId === "GOPAslifetobeAssuredandProposer")
          temp.pages[0].sections[0].component_groups[componentNameFreeze].components[0]["disabled"] = true
          temp.pages[0].sections[0].component_groups[componentEmailFreeze].components[0]["disabled"] = true
          // temp.pages[0].sections[0].component_groups[componentNumberFreeze].components[1]["disabled"] = true
          temp.pages[0].sections[0].component_groups[componentLifeToBeAssuredAndFreeze].components[0]["disabled"] = true
        }
      } else {
        if(journeyState.journeyIdFromStrapi === "pension4LifeJourney"){
          setSectionState(prev => {
            return {
              ...prev,
              sectionFirstPass: true,
              sectionData: {
                ...prev.sectionData,
                "lifeToBeAssuredPension4LIfe": "N",
                "proposerName": fullname,
                "proposerEmail": data?.emailId,
                "proposerNumber": data?.phoneNumber,
                "proposerCountryCode": data?.countryCode,
                // "GOPAannualIncome": data?.annualIncome,
                "DOBproposer": data?.birthDate,
                "annualIncomeProposer": data?.annualIncome,
                "proposerGender": lookup?.fnaGender?.[0][data.title]
              }
            }
          })
          setConditionState(prev => {
            return {
              ...prev,
              [`${pageId}.${sectionId}.lifeToBeAssuredPension4LIfe`]: "N",
              [`${pageId}.${sectionId}.proposerName`]: fullname,
              [`${pageId}.${sectionId}.proposerEmail`]: data?.emailId,
              [`${pageId}.${sectionId}.proposerNumber`]: data?.phoneNumber,
              [`${pageId}.${sectionId}.proposerCountryCode`]: data?.countryCode,
              [`${pageId}.${sectionId}.DOBproposer`]: data?.birthDate,
            }
          })
          let componentToBeChange = temp.pages[0].sections[0].component_groups.findIndex(element => element.componentId === "proposerDetailsPesnion4life")
          let componentNameFreeze = temp.pages[0].sections[0].component_groups[componentToBeChange].components.findIndex(element => element.formControlKey === "proposerName")
          let componentEmailFreeze = temp.pages[0].sections[0].component_groups[componentToBeChange].components.findIndex(element => element.formControlKey === "proposerEmail")
          let componentNumberFreeze = temp.pages[0].sections[0].component_groups[componentToBeChange].components.findIndex(element => element.formControlKey === "proposerNumber")
          temp.pages[0].sections[0].component_groups[componentToBeChange].components[componentNameFreeze]["disabled"] = true
          temp.pages[0].sections[0].component_groups[componentToBeChange].components[componentEmailFreeze]["disabled"] = true
          temp.pages[0].sections[0].component_groups[componentToBeChange].components[componentNumberFreeze]["disabled"] = false
        } else if(journeyState.journeyIdFromStrapi === "smartGuaranteedPensionJourney"){
          setSectionState(prev => {
            return {
              ...prev,
              sectionFirstPass: true,
              sectionData: {
                ...prev.sectionData,
                "GOPAslifetobeAssuredandProposer": "N",
                "GOPAProposername": fullname,
                "GOPAproposerEmail": data?.emailId,
                "GOPAnumber": data?.phoneNumber,
                "GOPAproposerCode": data?.countryCode,
                "GOPAproposerAnnualIncome": data?.annualIncome,
                "GOPAproposerGender": data?.birthDate,
                "proposerGender": lookup?.fnaGender?.[0][data.title]
              }
            }
          })
          setConditionState(prev => {
            return {
              ...prev,
              [`${pageId}.${sectionId}.GOPAslifetobeAssuredandProposer`]: "N",
              [`${pageId}.${sectionId}.GOPAProposername`]: fullname,
              [`${pageId}.${sectionId}.GOPAproposerEmail`]: data?.emailId,
              [`${pageId}.${sectionId}.GOPAnumber`]: data?.phoneNumber,
              [`${pageId}.${sectionId}.GOPAproposerCode`]: data?.countryCode,
              [`${pageId}.${sectionId}.GOPAproposerGender`]: data?.birthDate,
            }
          })
          let componentToBeChange = temp.pages[0].sections[0].component_groups.findIndex(element => element.componentId === "GOPAproposerDetails")
          let componentNameFreeze = temp.pages[0].sections[0].component_groups[componentToBeChange].components.findIndex(element => element.formControlKey === "GOPAProposername")
          let componentEmailFreeze = temp.pages[0].sections[0].component_groups[componentToBeChange].components.findIndex(element => element.formControlKey === "GOPAproposerEmail")
          let componentNumberFreeze = temp.pages[0].sections[0].component_groups[componentToBeChange].components.findIndex(element => element.formControlKey === "GOPAnumber")
          temp.pages[0].sections[0].component_groups[componentToBeChange].components[componentNameFreeze]["disabled"] = true
          temp.pages[0].sections[0].component_groups[componentToBeChange].components[componentEmailFreeze]["disabled"] = true
          temp.pages[0].sections[0].component_groups[componentToBeChange].components[componentNumberFreeze]["disabled"] = true
        }
      }
      // setSectionState(prev => {
      //   return {
      //     ...prev,
      //     sectionData: {
      //       ...prev.sectionData,
      //       "CPPersonalDetailName": fullname,
      //       "email": data?.emailId,
      //       "contactNo": data?.phoneNumber,
      //       "mobileNumber": data?.countryCode,
      //       "annualIncome": data?.annualIncome,
      //       "dateOfBirth": data?.birthDate
      //     }
      //   }
      // })
  
      console.log("HIIIII");
    },[props.canaraPosData])

    // hsbc journey
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      if(props?.hsbcBankData && props.hsbcBankData?.hsbcId || fnaHsbcData){
        let data = props?.hsbcBankData || fnaHsbcData
        let pageId = journeyState?.journeySteps?.pages?.[0]?.pageId
        let sectionId = journeyState?.journeySteps?.pages?.[0]?.sections?.[0]?.sectionId
        let thirdPageId = journeyState?.journeySteps?.pages?.[2]?.pageId
        let thirdSectionId = journeyState?.journeySteps?.pages?.[2]?.sections?.[0]?.sectionId
        if(!data){
          return
        }
        let fullname = fullNameConverter(data?.firstName, data?.middleName, data?.lastName)
        console.log(fullname)
        console.log(data);
        setJourneyState(prev => {
          return({
            ...prev,
            channel: "A",
            journeyType: "HSBC",
            hsbcJourneyID: props.hsbcBankData?.hsbcId || data?.hsbcId,
            hsbcCustomerNumber: props.hsbcBankData?.hsbcCustomerNumber || data?.hsbcCustomerNumber,
          })
        })
        // setErrorState({})
        console.log(props);
        let temp = journeyState.journeySteps
          if(journeyState.journeyIdFromStrapi === "pension4LifeJourney" || journeyState.journeyIdFromStrapi === "smartGuaranteedPensionJourney"){
            let dobKey = 'DOBPension4life'
            if (journeyState.journeyIdFromStrapi === "smartGuaranteedPensionJourney"){
              dobKey = 'smartGuaranteedPensionDOB'
            }
            setSectionState(prev => {
              return {
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  "namePension4life": fullname,
                  "emailPension4life": data?.email,
                  "contactNoPension4life": data?.phone,
                  [dobKey]: data?.dateOfBirth,
                  "genderPension4life": data.gender,
                  "laTitle": data?.title,
                  "taxResidenceCountry1": data?.taxResidenceCountry1 || null,
                  "taxResidenceCountry2": data?.taxResidenceCountry2 || null,
                  "taxResidenceCountry3": data?.taxResidenceCountry3 || null,
                  "pan": data?.pan,
                  "CountryCodesPension4life": data?.phoneCountryCode,
                  "PinCodePension4life" : data?.pincode,
                  "CountryOfCurrentPension4life" : data?.currentCountry
                }
              }
            })
            setConditionState(prev => {
              return {
                ...prev,
                [`${pageId}.${sectionId}.namePension4life`]: fullname,
                [`${pageId}.${sectionId}.emailPension4life`]: data?.email,
                [`${pageId}.${sectionId}.contactNoPension4life`]: data?.phone,
                [`${pageId}.${sectionId}.CountryCodesPension4life`]: data?.countryCode,
                [`${pageId}.${sectionId}.CountryCodesPension4life`]: data?.phoneCountryCode,
                [`${pageId}.${sectionId}.${dobKey}`]: data?.dateOfBirth,
                [`${pageId}.${sectionId}.genderPension4life`]: data.gender,
                [`${pageId}.${sectionId}.laTitle`]: data?.title,
                [`${pageId}.${sectionId}.PinCodePension4life`]: data?.pincode,
                [`${thirdPageId}.${thirdSectionId}.taxResidenceCountry1`]: data?.taxResidenceCountry1 || null,
                [`${thirdPageId}.${thirdSectionId}.taxResidenceCountry2`]: data?.taxResidenceCountry2 || null,
                [`${thirdPageId}.${thirdSectionId}.taxResidenceCountry3`]: data?.taxResidenceCountry3 || null,
                [`${thirdPageId}.${thirdSectionId}.pan`]: data?.pan
              }
            })
            // let componentNameFreeze = temp.pages[0].sections[0].component_groups.findIndex(element => element.componentId === "namePension4life")
            // let componentEmailFreeze = temp.pages[0].sections[0].component_groups.findIndex(element => element.componentId === "emailPension4life")
            // let componentNumberFreeze = temp.pages[0].sections[0].component_groups.findIndex(element => element.componentId === "contactNoPension4life")
            // temp.pages[0].sections[0].component_groups[componentNameFreeze].components[0]["disabled"] = true
            // temp.pages[0].sections[0].component_groups[componentEmailFreeze].components[0]["disabled"] = true
            // temp.pages[0].sections[0].component_groups[componentNumberFreeze].components[0]["disabled"] = true
            // temp.pages[0].sections[0].component_groups[componentNumberFreeze].components[1]["disabled"] = true
          }
        let tempName = journeyState.journeySteps
        let componentNameFreezetempName = tempName.pages[0].sections[0].component_groups.findIndex(element => element.componentId === "namePension4life")
        let nameComponent = tempName.pages[0].sections[0].component_groups[componentNameFreezetempName].components.findIndex(el => el.formControlKey === "namePension4life")
        tempName.pages[0].sections[0].component_groups[componentNameFreezetempName].components[nameComponent]["regex"] = "/^[a-zA-Z .']*$/"
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: tempName
          })
        })
      }
    },[props.hsbcBankData, fnaHsbcData])

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (!nvestFilterResult && journeyState.channel) {
      getIpAddress()
        .then(res => {
          let payload = {
            ip: res.IPv4
          }
          if (refreshToken) {
            let payload = {
              ProductId: journeyState.productId,
              Bank: getValueFromLookup("reverseChannelToNumber", journeyState.channel),
              journeyIdFromStrapi: journeyState.journeyIdFromStrapi
            }
            getAllInputQuotations(payload)
              .then(res => {
                if (res.status) {
                  let temp = res.data
                  let formInputsWithUnifiedKey = res.data.formInputs.filter(element => element.unified_keywordName)
                  temp.formInputs = formInputsWithUnifiedKey
                  console.log("inside all input quotations")
                  setNvestFilterResult(temp)
                  if (res.data.optionIds) {
                    setJourneyState(prev => {
                      return ({
                        ...prev,
                        optionValues: res.data.optionIds,
                        allUniquePtValues: res.data.allUniquePtValues,
                        allUniquePptValues: res.data.allUniquePptValues
                      })
                    })
                  }
                }
              })
              .catch(err => {
                console.log(err)
              })
          } else {
            getJWTTokenForIp(payload)
              .then(res => {
                let payload = {
                  ProductId: journeyState.productId,
                  Bank: getValueFromLookup("reverseChannelToNumber", journeyState.channel),
                  journeyIdFromStrapi: journeyState.journeyIdFromStrapi
                }
                getAllInputQuotations(payload)
                  .then(res => {
                    if (res.status) {
                      let temp = res.data
                      let formInputsWithUnifiedKey = res.data.formInputs.filter(element => element.unified_keywordName)
                      temp.formInputs = formInputsWithUnifiedKey
                      console.log("inside all input quotations")
                      setNvestFilterResult(temp)
                      if (res.data.optionIds) {
                        setJourneyState(prev => {
                          return ({
                            ...prev,
                            optionValues: res.data.optionIds,
                            allUniquePtValues: res.data.allUniquePtValues,
                            allUniquePptValues: res.data.allUniquePptValues
                          })
                        })
                      }
                    }
                  })
                  .catch(err => {
                    console.log(err)
                  })
              })
          }
        })
    }
  }, [journeyState.channel])

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    let temp = journeyState.journeySteps
    let tempPageIndex
    let tempSectionIndex
    let tempComponentGroupIndex
    let tempComponentIndex
    if (journeyState.journeyIdFromStrapi === "iSelectJourney") {
      tempPageIndex = temp.pages.findIndex(element => element.pageId === "calculatePremiumPage")
      tempSectionIndex = temp.pages[tempPageIndex].sections.findIndex(element => element.sectionId === "CPCustomizePlanSection")
      tempComponentGroupIndex = temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups.findIndex(element => element.componentId === "CPCustomizePlan")
      tempComponentIndex = temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components.findIndex(element => element.formControlKey === "CPCustomizePlanPaymentFrequency")
      if (journeyState.channel && journeyState.channel === "A") {
        temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components[tempComponentIndex]["lookupKey"] = "premiumFrequency_withoutSinglePremium"
      } else {
        temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components[tempComponentIndex]["lookupKey"] = "premiumFrequency"
      }
    } else if (journeyState.journeyIdFromStrapi === "ISelect360Journey") {
      tempPageIndex = temp.pages.findIndex(element => element.pageId === "PageISelect360CalculatePremium")
      tempSectionIndex = temp.pages[tempPageIndex].sections.findIndex(element => element.sectionId === "iSelect360CPCustomizePlanSection")
      tempComponentGroupIndex = temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups.findIndex(element => element.componentId === "iSelect360CPCustomizePlan")
      tempComponentIndex = temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components.findIndex(element => element.formControlKey === "iSelect360CPCustomizePlanPaymentFrequency")
      if (journeyState.channel && journeyState.channel === "A") {
        temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components[tempComponentIndex]["lookupKey"] = "premiumFrequency_withoutSinglePremium"
      } else {
        temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components[tempComponentIndex]["lookupKey"] = "premiumFrequency"
      }
    }

  }, [journeyState.channel])

  const callAllInputForIndividualSections = () => {
    if (!nvestFilterResult) {
      let payload = {
        ProductId: journeyState.productId,
        Bank: getValueFromLookup("reverseChannelToNumber", journeyState.channel),
        journeyIdFromStrapi: journeyState.journeyIdFromStrapi
      }
      getAllInputQuotations(payload)
        .then(res => {
          if (res.status) {
            let temp = res.data
            let formInputsWithUnifiedKey = res.data.formInputs.filter(element => element.unified_keywordName)
            temp.formInputs = formInputsWithUnifiedKey
            console.log("inside all input quotations")
            setNvestFilterResult(temp)
            if (res.data.optionIds) {
              setJourneyState(prev => {
                return ({
                  ...prev,
                  optionValues: res.data.optionIds,
                  allUniquePtValues: res.data.allUniquePtValues,
                  allUniquePptValues: res.data.allUniquePptValues
                })
              })
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
  const callAllInputForCustomPayload = (payload) => {
    getAllInputQuotations(payload)
      .then(res => {
        if (res.status) {
          let temp = res.data
          let formInputsWithUnifiedKey = res.data.formInputs.filter(element => element.unified_keywordName)
          temp.formInputs = formInputsWithUnifiedKey
          console.info("Something inside all input quotations")
          if (res.data.optionIds) {
            setJourneyState(prev => {
              return ({
                ...prev,
                optionValues: res.data.optionIds,
                allUniquePtValues: res.data.allUniquePtValues,
                allUniquePptValues: res.data.allUniquePptValues
              })
            })
          }
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    let payload;
    if (sectionState?.sectionData?.childsFuture === "Y" && sectionState.sectionData.childsAge) {
      payload = {
        ProductId: journeyState.productId,
        "REQUESTSOURCE": 4,
        "Child_Age": sectionState.sectionData?.childsAge,
      }
      console.info("SOMETHING - Y", payload)
      callAllInputForCustomPayload(payload)
    } else if (sectionState?.sectionData?.childsFuture === "N") {
      payload = {
        ProductId: journeyState.productId,
        "REQUESTSOURCE": 4
      }
      callAllInputForCustomPayload(payload)
    }
  }, [sectionState?.sectionData?.childsFuture, sectionState?.sectionData?.childsAge])
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (props.pageId === "PageGuaranteedOnePayCalculatePremium" && sections[currentSectionIndex]?.sectionId === "SectionGOPAPersonelDetails" && journeyState.journeyIdFromStrapi === "GuarateedOnePayJourney") {
      let temp = journeyState?.journeySteps;
      const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key, value) => {
        try {
          let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
          let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
          let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
          let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
          console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "======>ImpTemp0")
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
        } catch (err) {
          console.log(err, "=====>ErrorInPage.js===Line-152")
        }
      }
      if (sectionState?.sectionData?.GOPAslifetobeAssuredandProposer === "N") {
        changeJourneySteps("PageGuaranteedOnePayCalculatePremium", "SectionGOPAChooseYourPlan", "GopaCoverageOption", "GopaCoverageOption", "disabled", true)
      } else if (sectionState?.sectionData?.GOPAslifetobeAssuredandProposer === "Y") {
        changeJourneySteps("PageGuaranteedOnePayCalculatePremium", "SectionGOPAChooseYourPlan", "GopaCoverageOption", "GopaCoverageOption", "disabled", false)
      }
    }
  }, [sectionState?.sectionData])


  //useEffect to auto Fill data for sections of fill proposal form
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    //annuity proposal form
    if (props.pageId === "PageFlexiEdgeFillProposalForm"){
      if (!isFirstProposalPageCovered2.current){
        if (currentSectionIndex !== 0){
          return;
        }else{
          isFirstProposalPageCovered2.current = true
        }
      }
    }
    if (props.pageId === "PagePension4lifeFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionPension4lifePrimaryAnnuitantPersonalDetail") {
      if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
        autoFillData("PagePension4lifeFillProposalForm", "SectionPension4lifePrimaryAnnuitantPersonalDetail")
      }else{
        autoFillDataAndFreeze("PagePension4lifeFillProposalForm", "SectionPension4lifePrimaryAnnuitantPersonalDetail")
      }
    }
    else if (props.pageId === "PagePension4lifeFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionPension4lifePrimaryAnnuitantCommunicationDetails") {
      if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
        autoFillData("PagePension4lifeFillProposalForm", "SectionPension4lifePrimaryAnnuitantCommunicationDetails")
      }else{
        autoFillDataAndFreeze("PagePension4lifeFillProposalForm", "SectionPension4lifePrimaryAnnuitantCommunicationDetails")
      }
    }
    else if (props.pageId === "PagePension4lifeFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionPension4lifePrimaryAnnuitantOccupationDetails") {
      if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
        autoFillData("PagePension4lifeFillProposalForm", "SectionPension4lifePrimaryAnnuitantOccupationDetails")
      }else{
        autoFillDataAndFreeze("PagePension4lifeFillProposalForm", "SectionPension4lifePrimaryAnnuitantOccupationDetails")
      }
    }
    else if (props.pageId === "PagePension4lifeFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionPension4lifeSecondaryAnnuitantOccupationDetails") {
      if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
        autoFillData("PagePension4lifeFillProposalForm", "SectionPension4lifeSecondaryAnnuitantOccupationDetails")
      }else{
        autoFillDataAndFreeze("PagePension4lifeFillProposalForm", "SectionPension4lifeSecondaryAnnuitantOccupationDetails")
      }
    }
    else if (props.pageId === "PagePension4lifeFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionPension4LifeProposerOccupation") {
      if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
        autoFillData("PagePension4lifeFillProposalForm", "SectionPension4LifeProposerOccupation")
      }else{
        autoFillDataAndFreeze("PagePension4lifeFillProposalForm", "SectionPension4LifeProposerOccupation")
      }
    }
    else if (props.pageId === "PagePension4lifeFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionPension4lifeSecondaryAnnuitantPersonalDetail") {
      if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
        autoFillData("PagePension4lifeFillProposalForm", "SectionPension4lifeSecondaryAnnuitantPersonalDetail")
      }else{
        autoFillDataAndFreeze("PagePension4lifeFillProposalForm", "SectionPension4lifeSecondaryAnnuitantPersonalDetail")
      }
    }
    else if (props.pageId === "PagePension4lifeFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionPension4lifeSEcondaryAnnuitantCommunicationDetails") {
      if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
        autoFillData("PagePension4lifeFillProposalForm", "SectionPension4lifeSEcondaryAnnuitantCommunicationDetails")
      }else{
        autoFillDataAndFreeze("PagePension4lifeFillProposalForm", "SectionPension4lifeSEcondaryAnnuitantCommunicationDetails")
      }
    }
    else if (props.pageId === "PagePension4lifeFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionPension4LifeProposerPersonalDetail") {
      if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
        autoFillData("PagePension4lifeFillProposalForm", "SectionPension4LifeProposerPersonalDetail")
      }else{
        autoFillDataAndFreeze("PagePension4lifeFillProposalForm", "SectionPension4LifeProposerPersonalDetail")
      }
    }
    else if (props.pageId === "PagePension4lifeFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionPension4LifeProposerCommunication") {
      if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
        autoFillData("PagePension4lifeFillProposalForm", "SectionPension4LifeProposerCommunication")
      }else{
        autoFillDataAndFreeze("PagePension4lifeFillProposalForm", "SectionPension4LifeProposerCommunication")
      }
    }
    else if (props.pageId === "PagePension4lifeFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionPension4lifeFillProposalBankDetails") {
        autoFillDataAndFreeze("PagePension4lifeFillProposalForm", "SectionPension4lifeFillProposalBankDetails")
    }
    else if (props.pageId === "PagePension4lifeFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionPension4LifeNomineePersonalDetail") {
      if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
        autoFillData("PagePension4lifeFillProposalForm", "SectionPension4LifeNomineePersonalDetail")
      }else{
        autoFillDataAndFreeze("PagePension4lifeFillProposalForm", "SectionPension4LifeNomineePersonalDetail")
      }
    }

    //pension4Life Product Page
    else if (props.pageId === "PagePension4lifeCalculateAnnutiyInstallment" && sections[currentSectionIndex]?.sectionId === "SectionPension4lifePersonalDetailsofPrimaryAnnuitment") {
      if(journeyState.journeyId){
        autoFillData("PagePension4lifeCalculateAnnutiyInstallment", "SectionPension4lifePersonalDetailsofPrimaryAnnuitment")
      }
    }
    else if (props.pageId === "PageSmartGuaranteedPensionCalculatePremium" && sections[currentSectionIndex]?.sectionId === "SectionCommonResidenceAndOccupation" && journeyState?.journeyType?.toLowerCase() === "canarapos") {
      autoFillData(props.pageId, "SectionCommonResidenceAndOccupation")
    }
    else if (props.pageId === "PageSmartGuaranteedPensionCalculatePremium" && sections[currentSectionIndex]?.sectionId === "proposerCommonResidenceAndOccupation" && journeyState?.journeyType?.toLowerCase() === "canarapos") {
      autoFillData(props.pageId, "proposerCommonResidenceAndOccupation")
    }
    else if (props.pageId === "PagePension4lifeFillProposalForm" && sections[currentSectionIndex]?.sectionId === "sectionPension4LifeSecAnnuitantBankDetails") {
      if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
        autoFillData("PagePension4lifeFillProposalForm", "sectionPension4LifeSecAnnuitantBankDetails")
      }else{
        autoFillDataAndFreeze("PagePension4lifeFillProposalForm", "sectionPension4LifeSecAnnuitantBankDetails")
      }
    }
    else if (props.pageId === "PagePension4lifeFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionPension4lifeProposerBankDetails") {
      if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
        autoFillData("PagePension4lifeFillProposalForm", "SectionPension4lifeProposerBankDetails")
      }else{
        autoFillDataAndFreeze("PagePension4lifeFillProposalForm", "SectionPension4lifeProposerBankDetails")
      }
    }else if (props.pageId === "PageSmartGuaranteedPensionCalculatePremium" && sections[currentSectionIndex].sectionId === "SectionCommonResidenceAndOccupation"){
      autoFillData("PageSmartGuaranteedPensionCalculatePremium", "SectionCommonResidenceAndOccupation")
    }

  }, [props.currentPageIndex, currentSectionIndex, journeyState.journeyId])

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    let conditionStatePlanOptionKey
    if (journeyState.journeyIdFromStrapi === "iSelectJourney") {
      conditionStatePlanOptionKey = "calculatePremiumPage.CPCustomizePlanSection.CPCustomizePlanQuestionOne"
    } else if (journeyState.journeyIdFromStrapi === "ISelect360Journey") {
      conditionStatePlanOptionKey = "PageISelect360CalculatePremium.iSelect360CPCustomizePlanSection.iSelect360CPCustomizePlanQuestionOne"
    }
    // else if(journeyState.journeyIdFromStrapi === "FlexiEdgeJourney"){

    // }
    // else if(journeyState.journeyIdFromStrapi === "GuaranteedSavingJourney"){
    //   conditionStatePlanOptionKey = "PageGuaranteedSavingCalculatePremium.SectionGuaranteedSavingInvestmentDetails.planOption"
    // }
    else {
      return
    }
    if (conditionState[conditionStatePlanOptionKey]) {
      if (journeyState.optionValues[conditionState[conditionStatePlanOptionKey]]) {
        let ptValues = journeyState.optionValues[conditionState[conditionStatePlanOptionKey]].ptValues
        if (Object.keys(ptValues).length) {
          console.log("ptValues length exists")
          let lookupForPolicyTermUpto35 = JSON.parse(JSON.stringify(ptValues))
          delete lookupForPolicyTermUpto35["5"]
          delete lookupForPolicyTermUpto35["6"]
          delete lookupForPolicyTermUpto35["7"]
          delete lookupForPolicyTermUpto35["8"]
          delete lookupForPolicyTermUpto35["9"]
          // console.log(lookupForPolicyTermUpto35, "lookupForPolicyTermUpto35")
          // console.log(ptValues, "lookupForPolicyTerm")
          setJourneyState(prev => {
            return ({
              ...prev,
              policyTermLookup: ptValues,
              policyTermLookupUpto35: lookupForPolicyTermUpto35
            })
          })
        }
      }
    } else if (journeyState.planOption) {
      if (journeyState.optionValues[journeyState.planOption]) {
        let ptValues = journeyState.optionValues[journeyState.planOption].ptValues
        if (Object.keys(ptValues).length) {
          console.log("ptValues length exists")
          let lookupForPolicyTermUpto35 = JSON.parse(JSON.stringify(ptValues))
          delete lookupForPolicyTermUpto35["5"]
          delete lookupForPolicyTermUpto35["6"]
          delete lookupForPolicyTermUpto35["7"]
          delete lookupForPolicyTermUpto35["8"]
          delete lookupForPolicyTermUpto35["9"]

          setJourneyState(prev => {
            return ({
              ...prev,
              policyTermLookup: ptValues,
              policyTermLookupUpto35: lookupForPolicyTermUpto35
            })
          })
        }
      }
    }
  }, [journeyState.optionValues])

    //rider restriction
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      if (journeyState.journeyIdFromStrapi === "pension4LifeJourney" && sections[currentSectionIndex]?.sectionId === "SectionPension4lifePersonalDetailsofPrimaryAnnuitment" && sectionState?.sectionData?.primaryExactNatureOfOccupation) {
        let payload = {
          "ProductId": "90081",
          "Occupation": sectionState?.sectionData?.primaryExactNatureOfOccupation
        }
        getAllInputQuotations(payload)
        .then(res => {
          console.log(res)
          if (res.status) {
            if (res.data.planOptionList) {
              setJourneyState(prev => {
                return ({
                  ...prev,
                  planOptionList: res.data.planOptionList,
                })
              })
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
      }
    }, [sectionState?.sectionData?.primaryExactNatureOfOccupation])

  /*Helper Functions Start*/
  
  //Code to fill data on API call
  const autoFillData = async (pageId, sectionId) => {
    let payload = {
      _id: journeyState.journeyId,
    }
    fetchApplicationDetails(payload)
      .then(async res => {
        let fetchedPageIndex = res.applicationData.findIndex(element => element.pageId === pageId)
        if (fetchedPageIndex !== -1) {
          let fetchedSectionIndex = res.applicationData[fetchedPageIndex].pageData.findIndex(element => element.sectionId === sectionId)
          if (fetchedSectionIndex !== -1) {
            let valueObject = {}
            let conditionObject = {}
            let requiredSectionData = res.applicationData[fetchedPageIndex].pageData[fetchedSectionIndex].sectionData
            Object.keys(requiredSectionData).forEach(element => {
              if (requiredSectionData[element]) {
                valueObject[element] = requiredSectionData[element]
                conditionObject[`${pageId}.${sectionId}.${element}`] = requiredSectionData[element]
              }
            })
            console.log(valueObject, "value object")
            console.log(conditionObject, "condition object")
            setConditionState(prev => {
              return {
                ...prev,
                ...conditionObject
              }
            })
            if (sectionId === "iSelect360CPOptionalInBuilt" || sectionId === "iSelect360CPSpouseCoverDetails") {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionData: {
                    ...valueObject
                  }
                }
              })
            } else {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    ...valueObject
                  }
                }
              })
            }

            let lookupKeyForTitle = "title"
            let lookupKeyforProposerTitle = "title"
            if(sectionId === "SectionPension4lifePrimaryAnnuitantPersonalDetail"){
              if (valueObject["PDGender"] === "M") {
                valueObject["fullNameTitle"] = "MR"
                conditionObject[`${pageId}.${sectionId}.fullNameTitle`] = "MR"
              } else if (valueObject["PDGender"] === "F") {
                valueObject["fullNameTitle"] = valueObject["fullNameTitle"] ? valueObject["fullNameTitle"] : ""
                lookupKeyForTitle = "title-female"
              }
            } else if (valueObject["proposerPDGender"] === "M") {
              valueObject["ProposerfullNameTitle"] = "MR"
              conditionObject[`${pageId}.${sectionId}.ProposerfullNameTitle`] = "MR"
            } else if (valueObject["proposerPDGender"] === "F") {
              valueObject["ProposerfullNameTitle"] = valueObject["ProposerfullNameTitle"] ? valueObject["ProposerfullNameTitle"] : ""
              lookupKeyforProposerTitle = "title-female"
            }
            if (sectionId === "CPResidentAndOccupationDetailSection" || sectionId === "iSelect360CPResidentAndOccupationDetailSection") {
              if (journeyState.residenceDetailEmailTrigger === false) {
                let sendEmailPayload = {
                  journeyId: journeyState.journeyId,
                  module: "QUOTESMSEMAIL",
                  residenceDetailEmailTrigger: true
                }
                // sendEmailBI(sendEmailPayload).then(res => {
                //   console.log(res, "emailRes")
                //   if (res?.status) {
                //     successToastr(res.message)
                //   } else {
                //     errorToastr(res.message)
                //   }
                // })
                setJourneyState(prev => {
                  return ({
                    ...prev,
                    residenceDetailEmailTrigger: true
                  })
                })
              }

            }
            
            if(sectionState.sectionData){
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionFirstPass: true,
                }
              })
            }
            if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
              if (pageId === "PagePension4lifeFillProposalForm" && sectionId === "SectionPension4lifePrimaryAnnuitantPersonalDetail"){
                const pages = journeyState.journeySteps?.pages || []
                const tempPageIndexToChange = pages.findIndex(page => page.pageId === "PagePension4lifeFillProposalForm")
                const tempSectionIndexToChange = pages[tempPageIndexToChange]?.sections?.findIndex(section => section.sectionId === "SectionPension4lifePrimaryAnnuitantPersonalDetail")
                const tempNameComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "PDFullName")
                const tempNameComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempNameComponentGroupIndexToChange].components
                tempNameComponents.forEach(nameComponent => {
                  if (valueObject?.[nameComponent?.formControlKey]){
                    nameComponent.disabled = true;
                  }
                })
                const tempEmailComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "PDEmail")
                const tempEmailComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempEmailComponentGroupIndexToChange].components
                tempEmailComponents.forEach(emailComponent => {
                  if (valueObject?.[emailComponent?.formControlKey]){
                    emailComponent.disabled = true;
                  }
                })
                const tempDOBComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "PDDob")
                const tempDOBComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempDOBComponentGroupIndexToChange].components
                tempDOBComponents.forEach(dobComponent => {
                  if (valueObject?.[dobComponent?.formControlKey]){
                    dobComponent.disabled = true;
                  }
                })

                const tempAnnualIncomeComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "PDAnnualIncome")
                const tempAnnualIncomeComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempAnnualIncomeComponentGroupIndexToChange].components
                tempAnnualIncomeComponents.forEach(annualIncomeComponent => {
                  if (valueObject?.[annualIncomeComponent?.formControlKey]){
                    annualIncomeComponent.disabled = true;
                  }
                })
              }
              if (pageId === "PagePension4lifeFillProposalForm" && sectionId === "SectionPension4lifePrimaryAnnuitantCommunicationDetails"){
                const pages = journeyState.journeySteps?.pages || []
                const tempPageIndexToChange = pages.findIndex(page => page.pageId === "PagePension4lifeFillProposalForm")
                const tempSectionIndexToChange = pages[tempPageIndexToChange]?.sections?.findIndex(section => section.sectionId === "SectionPension4lifePrimaryAnnuitantCommunicationDetails")

                const tempCountryComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "CDcountry")
                const tempCountryComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempCountryComponentGroupIndexToChange].components
                tempCountryComponents.forEach(countryComponent => {
                  if (valueObject?.[countryComponent?.formControlKey]){
                    countryComponent.disabled = true;
                  }
                })

                const tempPinCodeComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "CDpincode")
                const tempPinCodeComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempPinCodeComponentGroupIndexToChange].components
                tempPinCodeComponents.forEach(pincodeComponent => {
                  if (valueObject?.[pincodeComponent?.formControlKey]){
                    pincodeComponent.disabled = true;
                  }
                })


                const tempStateComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "CDState")
                const tempStateComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempStateComponentGroupIndexToChange].components
                tempStateComponents.forEach(stateComponent => {
                  if (valueObject?.[stateComponent?.formControlKey]){
                    stateComponent.disabled = true;
                  }
                })

                const tempCityComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "CDCity")
                const tempCityComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempCityComponentGroupIndexToChange].components
                tempCityComponents.forEach(cityComponent => {
                  if (valueObject?.[cityComponent?.formControlKey]){
                    cityComponent.disabled = true;
                  }
                })

                const tempContactComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "mobileWithISDcode")
                const tempContacComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempContactComponentGroupIndexToChange].components
                tempContacComponents.forEach(contactComponent => {
                  if (valueObject?.[contactComponent?.formControlKey]){
                    contactComponent.disabled = true;
                  }
                })

              }
              if (pageId === "PagePension4lifeFillProposalForm" && sectionId === "SectionPension4LifeProposerPersonalDetail"){
                const pages = journeyState.journeySteps?.pages || []
                const tempPageIndexToChange = pages.findIndex(page => page.pageId === "PagePension4lifeFillProposalForm")
                const tempSectionIndexToChange = pages[tempPageIndexToChange]?.sections?.findIndex(section => section.sectionId === "SectionPension4LifeProposerPersonalDetail")
                const tempNameComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "proposerPDFullName")
                const tempNameComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempNameComponentGroupIndexToChange].components
                tempNameComponents.forEach(nameComponent => {
                  if (valueObject?.[nameComponent?.formControlKey]){
                    nameComponent.disabled = true;
                  }
                })

                const tempEmailComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "porposerPDEmail")
                const tempEmailComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempEmailComponentGroupIndexToChange].components
                tempEmailComponents.forEach(emailComponent => {
                  if (valueObject?.[emailComponent?.formControlKey]){
                    emailComponent.disabled = true;
                  }
                })

                const tempDOBComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "proposerPDDob")
                const tempDOBComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempDOBComponentGroupIndexToChange].components
                tempDOBComponents.forEach(dobComponent => {
                  if (valueObject?.[dobComponent?.formControlKey]){
                    dobComponent.disabled = true;
                  }
                })

                const tempAnnualIncomeComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "proposerPDAnnualIncome")
                const tempAnnualIncomeComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempAnnualIncomeComponentGroupIndexToChange].components
                tempAnnualIncomeComponents.forEach(annualIncomeComponent => {
                  if (valueObject?.[annualIncomeComponent?.formControlKey]){
                    annualIncomeComponent.disabled = true;
                  }
                })
              }
              if (pageId === "PagePension4lifeFillProposalForm" && sectionId === "SectionPension4LifeProposerCommunication"){
                const pages = journeyState.journeySteps?.pages || []
                const tempPageIndexToChange = pages.findIndex(page => page.pageId === "PagePension4lifeFillProposalForm")
                const tempSectionIndexToChange = pages[tempPageIndexToChange]?.sections?.findIndex(section => section.sectionId === "SectionPension4LifeProposerCommunication")

                const tempCountryComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "proposerCDcountry")
                const tempCountryComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempCountryComponentGroupIndexToChange].components
                tempCountryComponents.forEach(countryComponent => {
                  if (valueObject?.[countryComponent?.formControlKey]){
                    countryComponent.disabled = true;
                  }
                })

                const tempPinCodeComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "proposerCDpincode")
                const tempPinCodeComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempPinCodeComponentGroupIndexToChange].components
                tempPinCodeComponents.forEach(pincodeComponent => {
                  if (valueObject?.[pincodeComponent?.formControlKey]){
                    pincodeComponent.disabled = true;
                  }
                })


                const tempStateComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "proposerCDState")
                const tempStateComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempStateComponentGroupIndexToChange].components
                tempStateComponents.forEach(stateComponent => {
                  if (valueObject?.[stateComponent?.formControlKey]){
                    stateComponent.disabled = true;
                  }
                })

                const tempCityComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "proposerCDCity")
                const tempCityComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempCityComponentGroupIndexToChange].components
                tempCityComponents.forEach(cityComponent => {
                  if (valueObject?.[cityComponent?.formControlKey]){
                    cityComponent.disabled = true;
                  }
                })
              }
            }
            // if(pageId === "calculatePremiumPage" && sectionId === "CPCustomizePlanSection"){
            //   let payload = {
            //     ProductId: journeyState.productId,
            //     PT: valueObject["CPCustomizePlanPolicyTerm"]
            //   }
            //   getAllInputQuotations(payload)
            //   .then(res => {
            //     if(res.status){
            //       let temp = res.data
            //       let formInputsWithUnifiedKey = res.data.formInputs.filter(element => element.unified_keywordName)
            //       temp.formInputs = formInputsWithUnifiedKey
            //       console.log( "inside all input quotations")
            //       setNvestFilterResult(temp)
            //     }
            //   })
            //   .catch(err => {
            //     console.log(err)
            //   })
            // }
            valueObject = {}
            conditionObject = {}
          }
        }
      })
  }

  const tempNewObject = (res, pageId, sectionId) =>{
    const temp = journeyState.journeySteps
    const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key, value) => {
              try {
                let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
                let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
                let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
                let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
                console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "======>ImpTemp0")
                temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
              } catch (err) {
                console.log(err, "=====>ErrorInPage.js===Line-152")
              }
    }
            let fetchedPageIndex = res.applicationData.findIndex(element => element.pageId === pageId)
        if (fetchedPageIndex) {
          let fetchedSectionIndex = res.applicationData[fetchedPageIndex].pageData.findIndex(element => element.sectionId === sectionId)
          if (fetchedSectionIndex !== -1) {
            let valueObject = {}
            let conditionObject = {}
            let requiredSectionData = res.applicationData[fetchedPageIndex].pageData[fetchedSectionIndex].sectionData

            /* Autofillinf Data*/
            Object.keys(requiredSectionData).forEach(element => {
              if (requiredSectionData[element]) {
                valueObject[element] = requiredSectionData[element]
                conditionObject[`${pageId}.${sectionId}.${element}`] = requiredSectionData[element]
              }
            })
            console.log(valueObject, conditionObject, "dcdvdv")

            /*Hardcoding for particular fields*/
            let lookupKeyForTitle = "title"
            let lookupKeyforProposerTitle = "title"
            if(sectionId === "SectionPension4lifePrimaryAnnuitantPersonalDetail"){
              if (valueObject["PDGender"] === "M") {
                valueObject["fullNameTitle"] = "MR"
                conditionObject[`${pageId}.${sectionId}.fullNameTitle`] = "MR"
              } else if (valueObject["PDGender"] === "F") {
                valueObject["fullNameTitle"] = valueObject["fullNameTitle"] ? valueObject["fullNameTitle"] : ""
                lookupKeyForTitle = "title-female"
              }
            } else if (valueObject["proposerPDGender"] === "M") {
              valueObject["ProposerfullNameTitle"] = "MR"
              conditionObject[`${pageId}.${sectionId}.ProposerfullNameTitle`] = "MR"
            } else if (valueObject["proposerPDGender"] === "F") {
              valueObject["ProposerfullNameTitle"] = valueObject["ProposerfullNameTitle"] ? valueObject["ProposerfullNameTitle"] : ""
              lookupKeyforProposerTitle = "title-female"
            }
            let lookupForAccountTypeProposer = "accountTypeForProposer"
            if (res?.journeyData?.proposerDetails?.communicationDetails?.currentAddress?.country === "IN") {
              // valueObject["accountTypeProposer"] = valueObject["accountTypeProposer"] ? valueObject["accountTypeProposer"] : ""
              lookupForAccountTypeProposer = "accountTypeForProposerWithoutNRE"
            }
            let lookupForSecAnnuintant = "nomineeRelationshipWithLAMale"
            if(res?.journeyData?.spouseDetails?.gender === "F"){
              lookupForSecAnnuintant = "nomineeRelationshipWithLAFemale"
            }

            let lookupKeyForIdProof = "ID_PROOF"
            let lookupForAgeProof = "AGE_PROOF_IN"
            let lookupKeyForAddProof = "ADDRESS_PROOF"
            let lookupKeyForProposerIdProof = "ID_PROOF"
            let lookupKeyForProposerAddProof = "ADDRESS_PROOF"
            let lookupForResidentCountry = "residentStatus"
            let lookupKeyForAddProofPermanent = "ADDRESS_PROOF"
            let lookupKeyForAddProofPermanentProposer = "ADDRESS_PROOF"
            if (sectionId === "personalDetailsSection") {
              if (res?.journeyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.country !== "IN") {
                valueObject["prrofIdAge"] = "01"
                conditionObject[`${pageId}.${sectionId}.prrofIdAge`] = "01"
              } else {
                if (!(res?.journeyData?.lifeAssuredDetails?.proceedWith === "ekyc" || res?.journeyData?.lifeAssuredDetails?.proceedWith === "ckyc")) {
                  valueObject["prrofIdAge"] = "03"
                  conditionObject[`${pageId}.${sectionId}.prrofIdAge`] = "03"
                  lookupKeyForIdProof = "ID_PROOF_PAN"
                }
              }
              if (res?.journeyData?.productDetails?.spouseLaDetails?.wishToSecure === "02") {
                valueObject["maritalStatus"] = "M"
                conditionObject[`${pageId}.${sectionId}.maritalStatus`] = "M"
              }

            }

             if (sectionId === "SectionPension4lifePrimaryAnnuitantPersonalDetail" && (journeyState.journeyIdFromStrapi === "pension4LifeJourney" || journeyState.journeyIdFromStrapi === "smartGuaranteedPensionJourney")) {
              if (res?.journeyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.countryCodeMap && (res?.journeyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.countryCodeMap !== "+91")) {
                valueObject["PDagePROOF"] = "02"
                valueObject["PDidentityProof"] = "01"
                valueObject["PDAddressPROOF"] = "01"
                valueObject["PDResidentialStatus"] = "Y"
                let valueForMobileNumber
                if (journeyState.journeyIdFromStrapi === "pension4LifeJourney") {
                  valueForMobileNumber = conditionState["PagePension4lifeCalculateAnnutiyInstallment.SectionPension4lifePersonalDetailsofPrimaryAnnuitment.CountryCodesPension4life"]
                }else if (journeyState.journeyIdFromStrapi === "smartGuaranteedPensionJourney"){
                  valueForMobileNumber = conditionState["PageSmartGuaranteedPensionCalculatePremium.SectionSmartGuaranteedPensionPersonalDetails.CountryCodesPension4life"]
                }
                valueObject["PDcountryOfBirth"] = getValueFromLookup("countryCodeToCountry", valueForMobileNumber)
                valueObject["PDcurrentCountryofResidence"] = getValueFromLookup("countryCodeToCountry", valueForMobileNumber)
                valueObject["PDTaxResidenceCountry"] = getValueFromLookup("countryCodeToCountry", valueForMobileNumber)
                conditionObject[`${pageId}.${sectionId}.PDagePROOF`] = "02"
                conditionObject[`${pageId}.${sectionId}.PDidentityProof`] = "01"
                conditionObject[`${pageId}.${sectionId}.PDAddressPROOF`] = "01"
                conditionObject[`${pageId}.${sectionId}.PDResidentialStatus`] = "Y"
                conditionObject[`${pageId}.${sectionId}.PDcountryOfBirth`] = getValueFromLookup("countryCodeToCountry", valueForMobileNumber)
                lookupForResidentCountry = "residentStatus"
                valueObject["state"] = "NR"
                changeJourneySteps("PagePension4lifeFillProposalForm", "SectionPension4lifePrimaryAnnuitantPersonalDetail", "PDCurrentState", "PDCurrentState", "lookupKey", "state")
                changeJourneySteps("PagePension4lifeFillProposalForm", "SectionPension4lifePrimaryAnnuitantPersonalDetail", "PDNationality", "PDNationality", "disabled", false)
                changeJourneySteps("PagePension4lifeFillProposalForm", "SectionPension4lifePrimaryAnnuitantPersonalDetail", "PDTaxResidenceCountry", "PDTaxResidenceCountry", "disabled", false)
                changeJourneySteps("PagePension4lifeFillProposalForm", "SectionPension4lifePrimaryAnnuitantPersonalDetail", "PDCitizenship", "PDCitizenship", "disabled", false)
              } else {
                if((res?.journeyData?.lifeAssuredDetails?.kycVerified === true || res?.journeyData?.lifeAssuredDetails?.ckycVerified === true) && res?.journeyData?.lifeAssuredDetails?.addressProceedWith !== "permanentAddress"){
                  valueObject["PDAddressPROOF"] = "21"
                  conditionObject[`${pageId}.${sectionId}.PDAddressPROOF`] = "21"
                  lookupKeyForAddProof = "ADDRESS_PROOF_VERIFIED"
                }
                if(res?.journeyData?.lifeAssuredDetails?.kycVerified === true || res?.journeyData?.lifeAssuredDetails?.ckycVerified === true){
                  lookupForAgeProof = "AGE_PROOF"
                }
              }
            }
            else if (sectionId === "SectionPension4LifeProposerPersonalDetail" && (journeyState.journeyIdFromStrapi === "pension4LifeJourney" || journeyState.journeyIdFromStrapi === "smartGuaranteedPensionJourney")) {
              if (res?.journeyData?.proposerDetails?.communicationDetails?.contactDetails?.countryCode && (res?.journeyData?.proposerDetails?.communicationDetails?.contactDetails?.countryCode !== "+91")) {
                valueObject["proposerPDagePROOF"] = "02"
                valueObject["proposerPDidentityProof"] = "01"
                valueObject["proposerPDAddressPROOF"] = "01"
                valueObject["proposerPDResidentialStatus"] = "Y"
                let valueForMobileNumber
                if (journeyState.journeyIdFromStrapi === "pension4LifeJourney") {
                  valueForMobileNumber = conditionState["PagePension4lifeCalculateAnnutiyInstallment.SectionPension4lifePersonalDetailsofPrimaryAnnuitment.proposerCountryCode"]
                }else if (journeyState.journeyIdFromStrapi === "smartGuaranteedPensionJourney"){
                  valueForMobileNumber = conditionState["PageSmartGuaranteedPensionCalculatePremium.SectionSmartGuaranteedPensionPersonalDetails.GOPAproposerCode"]
                }
                valueObject["porposerPDcountryOfBirth"] = getValueFromLookup("countryCodeToCountry", valueForMobileNumber)
                valueObject["proposerPDcurrentCountryofResidence"] = getValueFromLookup("countryCodeToCountry", valueForMobileNumber)
                valueObject["proposerPDTaxResidenceCountry"] = getValueFromLookup("countryCodeToCountry", valueForMobileNumber)
                conditionObject[`${pageId}.${sectionId}.proposerPDagePROOF`] = "02"
                conditionObject[`${pageId}.${sectionId}.proposerPDidentityProof`] = "01"
                conditionObject[`${pageId}.${sectionId}.proposerPDAddressPROOF`] = "01"
                conditionObject[`${pageId}.${sectionId}.proposerPDResidentialStatus`] = "Y"
                conditionObject[`${pageId}.${sectionId}.PDcountryOfBirth`] = getValueFromLookup("countryCodeToCountry", valueForMobileNumber)
                lookupForResidentCountry = "residentStatus"
              } else {
                if((res?.journeyData?.proposerDetails?.kycVerified === true || res?.journeyData?.proposerDetails?.ckycVerified === true) && res?.journeyData?.proposerDetails?.addressProceedWith !== "permanentAddress"){
                  valueObject["proposerPDAddressPROOF"] = "21"
                  conditionObject[`${pageId}.${sectionId}.proposerPDAddressPROOF`] = "21"
                  lookupKeyForAddProof = "ADDRESS_PROOF_VERIFIED"
                }
                 if(res?.journeyData?.proposerDetails?.kycVerified === true || res?.journeyData?.proposerDetails?.ckycVerified === true){
                  lookupForAgeProof = "AGE_PROOF"
                }
                let valueForMobileNumber = '';
                if (journeyState.journeyIdFromStrapi === "pension4LifeJourney" || journeyState.journeyIdFromStrapi === "smartGuaranteedPensionJourney") {
                  valueForMobileNumber = conditionState["PagePension4lifeCalculateAnnutiyInstallment.SectionPension4lifePersonalDetailsofPrimaryAnnuitment.proposerCountryCode"]
                }
                valueObject["porposerPDcountryOfBirth"] = getValueFromLookup("countryCodeToCountry", valueForMobileNumber)
                valueObject["proposerPDcurrentCountryofResidence"] = getValueFromLookup("countryCodeToCountry", valueForMobileNumber)
                valueObject["proposerPDTaxResidenceCountry"] = getValueFromLookup("countryCodeToCountry", valueForMobileNumber)
              }
            }

            if (sectionId === "residenceDetailsSection") {
              if (res?.journeyData?.lifeAssuredDetails?.proceedWith === "ekyc" || res?.journeyData?.lifeAssuredDetails?.proceedWith === "ckyc") {
                if (res?.journeyData?.lifeAssuredDetails?.proceedWith === "ekyc" && res?.journeyData?.lifeAssuredDetails?.addressProceedWith === "permanentAddress") {
                  lookupKeyForAddProof = "ADDRESS_PROOF"
                } else {
                  lookupKeyForAddProof = "ADDRESS_PROOF_VERIFIED"
                }
              }
            }
            if (sectionId === "SectionPension4lifePrimaryAnnuitantCommunicationDetails") {
              if (res?.journeyData?.lifeAssuredDetails?.proceedWith === "ekyc" || res?.journeyData?.lifeAssuredDetails?.proceedWith === "ckyc") {
                if ((res?.journeyData?.lifeAssuredDetails?.proceedWith === "ekyc" || res?.journeyData?.lifeAssuredDetails?.proceedWith === "ckyc") && res?.journeyData?.lifeAssuredDetails?.addressProceedWith === "permanentAddress") {
                  lookupKeyForAddProof = "ADDRESS_PROOF"
                  lookupKeyForAddProofPermanent = "ADDRESS_PROOF_VERIFIED"
                } else {
                  lookupKeyForAddProof = "ADDRESS_PROOF_VERIFIED"
                }
              }
            }
            if (sectionId === "SectionPension4LifeProposerCommunication") {
              if (res?.journeyData?.proposerDetails?.proceedWith === "ekyc" || res?.journeyData?.proposerDetails?.proceedWith === "ckyc") {
                if ((res?.journeyData?.proposerDetails?.proceedWith === "ekyc" || res?.journeyData?.proposerDetails?.proceedWith === "ckyc") && res?.journeyData?.proposerDetails?.addressProceedWith === "permanentAddress") {
                  lookupKeyForAddProof = "ADDRESS_PROOF"
                  lookupKeyForAddProofPermanentProposer = "ADDRESS_PROOF_VERIFIED"
                } else {
                  lookupKeyForAddProof = "ADDRESS_PROOF_VERIFIED"
                }
              }
            }
            /*Hardcoding for particular fields Ends  */

            changeJourneySteps("PagePension4lifeFillProposalForm", "SectionPension4lifePrimaryAnnuitantPersonalDetail", "PDResidentialStatus", "PDResidentialStatus", "disabled", false)
            if(conditionState["PagePension4lifeCalculateAnnutiyInstallment.SectionPension4lifePersonalDetailsofPrimaryAnnuitment.CountryCodesPension4life"]==="+91" ||
              conditionState["PageSmartGuaranteedPensionCalculatePremium.SectionSmartGuaranteedPensionPersonalDetails.CountryCodesPension4life"]==="+91"
            ){
              valueObject["PDResidentialStatus"] = "N"
            }else{
              valueObject["PDResidentialStatus"] = "Y"
            }
            return valueObject
          }
        }
  }

  //Code to fill data on API call and freeze necessary fields
  const autoFillDataAndFreeze = async (pageId, sectionId) => {
    const temp = journeyState.journeySteps
    const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key, value) => {
              try {
                let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
                let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
                let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
                let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
                console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "======>ImpTemp0")
                temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
              } catch (err) {
                console.log(err, "=====>ErrorInPage.js===Line-152")
              }
    }
    let payload = {
      _id: journeyState.journeyId,
    }
    try {
    const res = await fetchApplicationDetails(payload)

        let fetchedPageIndex = res.applicationData.findIndex(element => element.pageId === pageId)
        if (fetchedPageIndex) {
          let fetchedSectionIndex = res.applicationData[fetchedPageIndex].pageData.findIndex(element => element.sectionId === sectionId)
          if (fetchedSectionIndex !== -1) {
            let valueObject = {}
            let conditionObject = {}
            let requiredSectionData = res.applicationData[fetchedPageIndex].pageData[fetchedSectionIndex].sectionData

            if (sectionId === "SectionPension4lifePrimaryAnnuitantPersonalDetail") {
              console.info('jouneyState', journeyState)
              if (journeyState?.journeyData?.[0]?.pageData?.[0]?.sectionData?.GOPAslifetobeAssuredandProposer == "N" || journeyState?.journeyData?.[0]?.pageData?.[0]?.sectionData?.islifetobeAssuredandProposer == "N" || journeyState?.journeyData?.[0]?.pageData?.[0]?.sectionData?.CFislifetobeAssuredandProposer == "N") {
                let temp = journeyState.journeySteps
                try{
                  const pageIndexx = temp.pages.findIndex(page => {
                    return page.pageId === pageId
                  })
                if (pageIndexx > -1) {
                  const sectionIndexx = temp.pages[pageIndexx].sections.findIndex(section => section.sectionId === sectionId)
                  if (sectionIndexx > -1) {
                    const componentGroupindexx = temp.pages[pageIndexx].sections[sectionIndexx].component_groups.findIndex(element => element.componentId === "PDAddressPROOF")
                    if (componentGroupindexx > -1) {
                      const componentIndexx = temp.pages[pageIndexx].sections[sectionIndexx].component_groups[componentGroupindexx].components.findIndex(element => element.formControlKey === "PDAddressPROOF")
                      if (componentIndexx > -1) {
                        temp.pages[pageIndexx].sections[sectionIndexx].component_groups[componentGroupindexx].components[componentIndexx].required = false;
                        temp.pages[pageIndexx].sections[sectionIndexx].component_groups[componentGroupindexx].components[componentIndexx].requiredError = null;

                        console.info("errorState" , errorState)
                        setJourneyState(prev => ({
                          ...prev,
                          journeySteps: temp
                        }))
                        setErrorState(prev => ({
                          ...prev,
                          ["PDAddressPROOF"]:''}))
                      }
                    }
                  }
                }
                } catch (error){
                  console.error(error, "=====>ErrorInPage.js===SectionFlexiEdgeFillProposalPersonalDetail")
                }
              }
            }
            /* Autofillinf Data*/
            Object.keys(requiredSectionData).forEach(element => {
              if (requiredSectionData[element]) {
                valueObject[element] = requiredSectionData[element]
                conditionObject[`${pageId}.${sectionId}.${element}`] = requiredSectionData[element]
              }
            })
            console.log(valueObject, conditionObject, "dcdvdv")

            /*Hardcoding for particular fields*/
            let lookupKeyForTitle = "title"
            let lookupKeyforProposerTitle = "title"
            if(sectionId === "SectionPension4lifePrimaryAnnuitantPersonalDetail"){
              if (valueObject["PDGender"] === "M") {
                valueObject["fullNameTitle"] = "MR"
                conditionObject[`${pageId}.${sectionId}.fullNameTitle`] = "MR"
              } else if (valueObject["PDGender"] === "F") {
                valueObject["fullNameTitle"] = valueObject["fullNameTitle"] ? valueObject["fullNameTitle"] : ""
                lookupKeyForTitle = "title-female"
              }
            } else if (valueObject["proposerPDGender"] === "M") {
              valueObject["ProposerfullNameTitle"] = "MR"
              conditionObject[`${pageId}.${sectionId}.ProposerfullNameTitle`] = "MR"
            } else if (valueObject["proposerPDGender"] === "F") {
              valueObject["ProposerfullNameTitle"] = valueObject["ProposerfullNameTitle"] ? valueObject["ProposerfullNameTitle"] : ""
              lookupKeyforProposerTitle = "title-female"
            }

            let lookupForAccountTypeProposer = "accountTypeForProposer"
            if (res?.journeyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.country === "IN") {
              // valueObject["accountType"] = valueObject["accountType"] ? valueObject["accountType"] : ""
              lookupForAccountTypeProposer = "accountTypeForProposerWithoutNRE"
            }
            let lookupForSecAnnuintant = "nomineeRelationshipWithLAMale"
            if(res?.journeyData?.spouseDetails?.gender === "F"){
              lookupForSecAnnuintant = "nomineeRelationshipWithLAFemale"
            }

            let lookupKeyForIdProof = "ID_PROOF"
            let lookupForAgeProof = "AGE_PROOF_IN"
            let lookupKeyForAddProof = "ADDRESS_PROOF"
            let lookupKeyForProposerIdProof = "ID_PROOF"
            let lookupKeyForProposerAddProof = "ADDRESS_PROOF"
            let lookupForResidentCountry = "residentStatus"
            let lookupKeyForAddProofPermanent = "ADDRESS_PROOF"
            let lookupKeyForAddProofPermanentProposer = "ADDRESS_PROOF"
            if (sectionId === "personalDetailsSection") {
              if (res?.journeyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.country !== "IN") {
                valueObject["prrofIdAge"] = "01"
                conditionObject[`${pageId}.${sectionId}.prrofIdAge`] = "01"
              } else {
                if (!(res?.journeyData?.lifeAssuredDetails?.proceedWith === "ekyc" || res?.journeyData?.lifeAssuredDetails?.proceedWith === "ckyc")) {
                  valueObject["prrofIdAge"] = "03"
                  conditionObject[`${pageId}.${sectionId}.prrofIdAge`] = "03"
                  lookupKeyForIdProof = "ID_PROOF_PAN"
                }
              }
              if (res?.journeyData?.productDetails?.spouseLaDetails?.wishToSecure === "02") {
                valueObject["maritalStatus"] = "M"
                conditionObject[`${pageId}.${sectionId}.maritalStatus`] = "M"
              }

            }

             if (sectionId === "SectionPension4lifePrimaryAnnuitantPersonalDetail" && (journeyState.journeyIdFromStrapi === "pension4LifeJourney" || journeyState.journeyIdFromStrapi === "smartGuaranteedPensionJourney")) {
              if (res?.journeyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.countryCodeMap && (res?.journeyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.countryCodeMap !== "+91")) {
                valueObject["PDagePROOF"] = "02"
                valueObject["PDidentityProof"] = "01"
                valueObject["PDAddressPROOF"] = "01"
                valueObject["PDResidentialStatus"] = "Y"
                let valueForMobileNumber
                if (journeyState.journeyIdFromStrapi === "pension4LifeJourney") {
                  valueForMobileNumber = conditionState["PagePension4lifeCalculateAnnutiyInstallment.SectionPension4lifePersonalDetailsofPrimaryAnnuitment.CountryCodesPension4life"]
                }else if (journeyState.journeyIdFromStrapi === "smartGuaranteedPensionJourney"){
                  valueForMobileNumber = conditionState["PageSmartGuaranteedPensionCalculatePremium.SectionSmartGuaranteedPensionPersonalDetails.CountryCodesPension4life"]
                }
                valueObject["PDcountryOfBirth"] = getValueFromLookup("countryCodeToCountry", valueForMobileNumber)
                valueObject["PDcurrentCountryofResidence"] = getValueFromLookup("countryCodeToCountry", valueForMobileNumber)
                valueObject["PDTaxResidenceCountry"] = getValueFromLookup("countryCodeToCountry", valueForMobileNumber)
                conditionObject[`${pageId}.${sectionId}.PDagePROOF`] = "02"
                conditionObject[`${pageId}.${sectionId}.PDidentityProof`] = "01"
                conditionObject[`${pageId}.${sectionId}.PDAddressPROOF`] = "01"
                conditionObject[`${pageId}.${sectionId}.PDResidentialStatus`] = "Y"
                conditionObject[`${pageId}.${sectionId}.PDcountryOfBirth`] = getValueFromLookup("countryCodeToCountry", valueForMobileNumber)
                lookupForResidentCountry = "residentStatus"
                valueObject["state"] = "NR"
                changeJourneySteps("PagePension4lifeFillProposalForm", "SectionPension4lifePrimaryAnnuitantPersonalDetail", "PDCurrentState", "PDCurrentState", "lookupKey", "state")
                changeJourneySteps("PagePension4lifeFillProposalForm", "SectionPension4lifePrimaryAnnuitantPersonalDetail", "PDNationality", "PDNationality", "disabled", false)
                changeJourneySteps("PagePension4lifeFillProposalForm", "SectionPension4lifePrimaryAnnuitantPersonalDetail", "PDTaxResidenceCountry", "PDTaxResidenceCountry", "disabled", false)
                changeJourneySteps("PagePension4lifeFillProposalForm", "SectionPension4lifePrimaryAnnuitantPersonalDetail", "PDCitizenship", "PDCitizenship", "disabled", false)
              } else {
                if((res?.journeyData?.lifeAssuredDetails?.kycVerified === true || res?.journeyData?.lifeAssuredDetails?.ckycVerified === true) && res?.journeyData?.lifeAssuredDetails?.addressProceedWith !== "permanentAddress"){
                  valueObject["PDAddressPROOF"] = "21"
                  conditionObject[`${pageId}.${sectionId}.PDAddressPROOF`] = "21"
                  lookupKeyForAddProof = "ADDRESS_PROOF_VERIFIED"
                }
                if(res?.journeyData?.lifeAssuredDetails?.kycVerified === true || res?.journeyData?.lifeAssuredDetails?.ckycVerified === true){
                  lookupForAgeProof = "AGE_PROOF"
                }
              }
            }
            else if (sectionId === "SectionPension4LifeProposerPersonalDetail" && (journeyState.journeyIdFromStrapi === "pension4LifeJourney" || journeyState.journeyIdFromStrapi === "smartGuaranteedPensionJourney")) {
              if (res?.journeyData?.proposerDetails?.communicationDetails?.contactDetails?.countryCode && (res?.journeyData?.proposerDetails?.communicationDetails?.contactDetails?.countryCode !== "+91")) {
                valueObject["proposerPDagePROOF"] = "02"
                valueObject["proposerPDidentityProof"] = "01"
                valueObject["proposerPDAddressPROOF"] = "01"
                valueObject["proposerPDResidentialStatus"] = "Y"
                let valueForMobileNumber
                if (journeyState.journeyIdFromStrapi === "pension4LifeJourney") {
                  valueForMobileNumber = conditionState["PagePension4lifeCalculateAnnutiyInstallment.SectionPension4lifePersonalDetailsofPrimaryAnnuitment.proposerCountryCode"]
                }else if (journeyState.journeyIdFromStrapi === "smartGuaranteedPensionJourney"){
                  valueForMobileNumber = conditionState["PageSmartGuaranteedPensionCalculatePremium.SectionSmartGuaranteedPensionPersonalDetails.GOPAproposerCode"]
                }
                valueObject["porposerPDcountryOfBirth"] = getValueFromLookup("countryCodeToCountry", valueForMobileNumber)
                valueObject["proposerPDcurrentCountryofResidence"] = getValueFromLookup("countryCodeToCountry", valueForMobileNumber)
                valueObject["proposerPDTaxResidenceCountry"] = getValueFromLookup("countryCodeToCountry", valueForMobileNumber)
                conditionObject[`${pageId}.${sectionId}.proposerPDagePROOF`] = "02"
                conditionObject[`${pageId}.${sectionId}.proposerPDidentityProof`] = "01"
                conditionObject[`${pageId}.${sectionId}.proposerPDAddressPROOF`] = "01"
                conditionObject[`${pageId}.${sectionId}.proposerPDResidentialStatus`] = "Y"
                conditionObject[`${pageId}.${sectionId}.PDcountryOfBirth`] = getValueFromLookup("countryCodeToCountry", valueForMobileNumber)
                lookupForResidentCountry = "residentStatus"
              } else {
                if((res?.journeyData?.proposerDetails?.kycVerified === true || res?.journeyData?.proposerDetails?.ckycVerified === true) && res?.journeyData?.proposerDetails?.addressProceedWith !== "permanentAddress"){
                  valueObject["proposerPDAddressPROOF"] = "21"
                  conditionObject[`${pageId}.${sectionId}.proposerPDAddressPROOF`] = "21"
                  lookupKeyForAddProof = "ADDRESS_PROOF_VERIFIED"
                }
                 if(res?.journeyData?.proposerDetails?.kycVerified === true || res?.journeyData?.proposerDetails?.ckycVerified === true){
                  lookupForAgeProof = "AGE_PROOF"
                }
                let valueForMobileNumber = '';
                if (journeyState.journeyIdFromStrapi === "pension4LifeJourney" || journeyState.journeyIdFromStrapi === "smartGuaranteedPensionJourney") {
                  valueForMobileNumber = conditionState["PagePension4lifeCalculateAnnutiyInstallment.SectionPension4lifePersonalDetailsofPrimaryAnnuitment.proposerCountryCode"]
                }
                valueObject["porposerPDcountryOfBirth"] = getValueFromLookup("countryCodeToCountry", valueForMobileNumber)
                valueObject["proposerPDcurrentCountryofResidence"] = getValueFromLookup("countryCodeToCountry", valueForMobileNumber)
                valueObject["proposerPDTaxResidenceCountry"] = getValueFromLookup("countryCodeToCountry", valueForMobileNumber)
              }
            }

            if (sectionId === "residenceDetailsSection") {
              if (res?.journeyData?.lifeAssuredDetails?.proceedWith === "ekyc" || res?.journeyData?.lifeAssuredDetails?.proceedWith === "ckyc") {
                if (res?.journeyData?.lifeAssuredDetails?.proceedWith === "ekyc" && res?.journeyData?.lifeAssuredDetails?.addressProceedWith === "permanentAddress") {
                  lookupKeyForAddProof = "ADDRESS_PROOF"
                } else {
                  lookupKeyForAddProof = "ADDRESS_PROOF_VERIFIED"
                }
              }
            }
            if (sectionId === "SectionPension4lifePrimaryAnnuitantCommunicationDetails") {
              if (res?.journeyData?.lifeAssuredDetails?.proceedWith === "ekyc" || res?.journeyData?.lifeAssuredDetails?.proceedWith === "ckyc") {
                if ((res?.journeyData?.lifeAssuredDetails?.proceedWith === "ekyc" || res?.journeyData?.lifeAssuredDetails?.proceedWith === "ckyc") && res?.journeyData?.lifeAssuredDetails?.addressProceedWith === "permanentAddress") {
                  lookupKeyForAddProof = "ADDRESS_PROOF"
                  lookupKeyForAddProofPermanent = "ADDRESS_PROOF_VERIFIED"
                } else {
                  lookupKeyForAddProof = "ADDRESS_PROOF_VERIFIED"
                }
              }
            }
            if (sectionId === "SectionPension4LifeProposerCommunication") {
              if (res?.journeyData?.proposerDetails?.proceedWith === "ekyc" || res?.journeyData?.proposerDetails?.proceedWith === "ckyc") {
                if ((res?.journeyData?.proposerDetails?.proceedWith === "ekyc" || res?.journeyData?.proposerDetails?.proceedWith === "ckyc") && res?.journeyData?.proposerDetails?.addressProceedWith === "permanentAddress") {
                  lookupKeyForAddProof = "ADDRESS_PROOF"
                  lookupKeyForAddProofPermanentProposer = "ADDRESS_PROOF_VERIFIED"
                } else {
                  lookupKeyForAddProof = "ADDRESS_PROOF_VERIFIED"
                }
              }
            }
            /*Hardcoding for particular fields Ends  */

            changeJourneySteps("PagePension4lifeFillProposalForm", "SectionPension4lifePrimaryAnnuitantPersonalDetail", "PDResidentialStatus", "PDResidentialStatus", "disabled", false)
            if(conditionState["PagePension4lifeCalculateAnnutiyInstallment.SectionPension4lifePersonalDetailsofPrimaryAnnuitment.CountryCodesPension4life"]==="+91" ||
              conditionState["PageSmartGuaranteedPensionCalculatePremium.SectionSmartGuaranteedPensionPersonalDetails.CountryCodesPension4life"]==="+91"
            ){
              valueObject["PDResidentialStatus"] = "N"
            }else{
              valueObject["PDResidentialStatus"] = "Y"
            }
            setSectionState(prev => {
              const newSectionData = tempNewObject(res, pageId, sectionId);
              return {
                ...prev,
                sectionId: sectionId,
                sectionData: {
                  ...prev.sectionData,
                  ...newSectionData
                }
              }
            })
            setConditionState(prev => {
              return {
                ...prev,
                ...conditionObject
              }
            })
            /* AutoFillingData */

            /*Freezing Data */

            if (firstPassForFreezingDataSections[sectionId]) {
              let temp = journeyState.journeySteps
              let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
              let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
              let componentGroups = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups
              console.log("23232323232332", componentGroups)
              componentGroups.forEach((componentGroup, componentGroupIndex) => {
                componentGroup.components.forEach((component, componentIndex) => {
                  // freezeJson?.[journeyState.journeyIdFromStrapi]?.[pageId]?.[sectionId]?.forEach(element => {
                  Object.keys(valueObject)?.forEach(element => {
                    if (element === component.formControlKey && element!=="PDResidentialStatus") {
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = true
                    }
                    if (element === component.formControlKey && element === "profesionalOccupationEmployerOrganization") {
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                    }
                    if (element === component.formControlKey && element === "fullNameTitle") {
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupKeyForTitle
                      if (valueObject["PDGender"] !== "M") {
                        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                      }
                    }
                    if (element === component.formControlKey && (element === "fathersFirstName" || element === "fathersMiddleName" || element === "fathersLastName" || element === "mothersFirstName" || element === "mothersMiddleName" || element === "mothersLastName")) {
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                    }
                    if (element === component.formControlKey && element === "ProposerfullNameTitle") {
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupKeyForTitle
                      if (valueObject["proposerPDGender"] !== "M") {
                        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                      }
                    }
                    if( element === component.formControlKey && element === "permanentAddressProof"){
                      console.log("23232323232332", element,tempPageIndexToChange,tempPageIndexToChange, tempPageIndexToChange,componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupKeyForAddProofPermanent
                    }
                    if( element === component.formControlKey && element === "permanentAddressProof" && sectionId === "SectionPension4LifeProposerCommunication"){
                      console.log("23232323232332", element,tempPageIndexToChange,tempPageIndexToChange, tempPageIndexToChange,componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupKeyForAddProofPermanentProposer
                    }
                    if (element === component.formControlKey && element === "accountTypeProposer") {
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupForAccountTypeProposer
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                    }
                    if (element === component.formControlKey && element === "RelationsipWithAnnuitant") {
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupForSecAnnuintant
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                    }
                    if (element === component.formControlKey && element === "ProposerfullNameTitle") {
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupKeyforProposerTitle
                      if (valueObject["proposergender"] !== "M") {
                        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                      }
                    }
                    if (element === component.formControlKey && element === "primaryAadhar") {
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      if(valueObject["primaryAadhar"]){
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["regex"] = "/^[a-zA-Z0-9]+$/"
                      } 
                    }
                    if (element === component.formControlKey && element === "aadharNumber") {
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      if(valueObject["aadharNumber"]){
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["regex"] = "/^[a-zA-Z0-9]+$/"
                      } 
                    }
                    
                    if (element === component.formControlKey && element === "residentialStatus") {
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupForResidentCountry
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                    }
                    if (element === component.formControlKey && element === "PDResidentialStatus") {
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupForResidentCountry
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                    }
                    if (element === component.formControlKey && element === "proposerPDResidentialStatus") {
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupForResidentCountry
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                    }
                    if (element === component.formControlKey && element === "countryofbirth") {

                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                    }
                    if (element === component.formControlKey && element === "PDTaxResidenceCountry") {

                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                    }
                    if (element === component.formControlKey && element === "PDcurrentCountryofResidence") {

                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                    }
                    if (element === component.formControlKey && element === "porposerPDcountryOfBirth") {

                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                    }
                    if (element === component.formControlKey && element === "proposerPDTaxResidenceCountry") {

                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                    }
                    if (element === component.formControlKey && element === "proposerPDcurrentCountryofResidence") {

                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                    }
                    if (element === component.formControlKey && (element === "prrofIdAge" || element === "ageIdentityProof")) {
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupKeyForIdProof
                      if (valueObject[element] === "03") {
                        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                      }
                    }
                    if (element === component.formControlKey && (element === "idProof")) {
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupKeyForProposerIdProof
                      if (valueObject[element] === "03") {
                        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                      }
                    }
                    if (element === component.formControlKey && (element === "PDagePROOF")) {
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupForAgeProof
                    }
                    if (element === component.formControlKey && (element === "PDidentityProof")) {
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupKeyForIdProof
                    }
                    if (element === component.formControlKey && (element === "proposerPDagePROOF")) {
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupForAgeProof
                    }
                    if (element === component.formControlKey && (element === "proposerPDidentityProof")) {
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupKeyForIdProof
                    }
                    if (element === component.formControlKey && (element === "PRAddressProof" || element === "addressProof")) {
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupKeyForAddProof
                      if (valueObject[element] === "01") {
                        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                      }
                    }
                    if (element === component.formControlKey && (element === "PDAddressPROOF")) {
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupKeyForAddProof
                      if (valueObject[element] === "01") {
                        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                      }
                    }
                    if (element === component.formControlKey && (element === "proposerPDAddressPROOF")) {
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupKeyForAddProof
                      if (valueObject[element] === "01") {
                        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                      }
                    }
                    if (element === component.formControlKey && (element === "currentAddressProof")) {
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupKeyForProposerAddProof
                      if (valueObject[element] === "01") {
                        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                      }
                    }

                  })
                })
              })
              if(sectionId === "SectionPension4lifePrimaryAnnuitantCommunicationDetails"){
                if(valueObject["addressSameAsResidence"] === "N"){
                  setSectionState(prev => {
                    return {
                      ...prev,
                      sectionId: sectionId,
                      sectionData: {
                        ...prev.sectionData,
                        ...valueObject
                      }
                    }
                  })
                }
              }
              if(sectionId === "SectionPension4lifePrimaryAnnuitantOccupationDetails" || sectionId === "SectionPension4LifeProposerOccupation"){
                if(valueObject["natureOfIndustry"]){
                  setSectionState(prev => {
                    return {
                      ...prev,
                      sectionId: sectionId,
                      sectionData: {
                        ...prev.sectionData,
                        ...valueObject
                      }
                    }
                  })
                }
              }
              if(sectionId === "SectionPension4LifeProposerCommunication"){
                if(valueObject["addressSameAsResidence"] === "N"){
                  setSectionState(prev => {
                    return {
                      ...prev,
                      sectionId: sectionId,
                      sectionData: {
                        ...prev.sectionData,
                        ...valueObject
                      }
                    }
                  })
                }
              }
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionId: sectionId,
                  sectionData: {
                    ...prev.sectionData,
                    ...valueObject
                  }
                }
              })
              setJourneyState(prev => {
                return ({
                  ...prev,
                  journeySteps: temp
                })
              })
            }
            setFirstPassForFreezingDataSections(prev => {
              return ({
                ...prev,
                [sectionId]: false
              })
            })
            if(sectionId === "SectionPension4lifePrimaryAnnuitantCommunicationDetails"){
              if(valueObject["addressSameAsResidence"] === "N"){
                setSectionState(prev => {
                  return {
                    ...prev,
                    sectionId: sectionId,
                    sectionData: {
                      ...prev.sectionData,
                      ...valueObject
                    }
                  }
                })
              }
            }
            if(sectionId === "SectionPension4lifePrimaryAnnuitantOccupationDetails" || sectionId === "SectionPension4LifeProposerOccupation"){
              if(valueObject["natureOfIndustry"]){
                setSectionState(prev => {
                  return {
                    ...prev,
                    sectionId: sectionId,
                    sectionData: {
                      ...prev.sectionData,
                      ...valueObject
                    }
                  }
                })
              }
            }
            if(sectionId === "SectionPension4LifeProposerCommunication"){
              if(valueObject["addressSameAsResidence"] === "N"){
                setSectionState(prev => {
                  return {
                    ...prev,
                    sectionId: sectionId,
                    sectionData: {
                      ...prev.sectionData,
                      ...valueObject
                    }
                  }
                })
              }
            }
            if(valueObject["primaryAadhar"]){
              setErrorState(prev => {
                return {
                  ...prev,
                  ["primaryAadhar"]: ""
                }
              })
            }

            if(valueObject["aadharNumber"]){
              setErrorState(prev => {
                return {
                  ...prev,
                  ["aadharNumber"]: ""
                }
              })
            }
            if(sectionState.sectionData){
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionFirstPass: true,
                }
              })
            }

            valueObject = {}
          }
        }
      } catch (error) {
        console.log("Error in Auto Filling Data", error)
      }
  }

  //Code to Check Nominee Percetage totals 100%
  const checkNomineePercentage = () => {
    // For Iselect Plans
    if (sectionState.sectionData["nomineePercent"]) {
      let values = sectionState.sectionData["nomineePercent"]
      if (values) {
        let total
        if (values.length === 1) {
          total = parseInt(values[0])
        } else {
          if (values.length > 1) {
            total = values?.reduce((a, b) => {
              return parseInt(a) + parseInt(b)
            })
          }
        }
        let temp
        let temp1
        if (errorState["nomineePercent"]) {
          temp1 = errorState["nomineePercent"]
        } else {
          temp1 = []
        }
        if (total !== 100) {
          const numberOfNominees = sectionState.sectionData["nomineePercent"].length
          for (let i = 0; i < numberOfNominees; i++) {
            temp1[i] = "Total of Nominee Percentages must be 100"
          }
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              ["nomineePercent"]: temp,
            }
          })
        } else {
          const numberOfNominees = sectionState.sectionData["nomineePercent"].length
          for (let i = 0; i < numberOfNominees; i++) {
            temp1[i] = ""
          }
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              ["nomineePercent"]: temp,
            }
          })
        }
      }

    }
    // For CPF plan
    else if (sectionState.sectionData["nomineePercentCPF"]) {
      let values = sectionState.sectionData["nomineePercentCPF"]
      if (values) {
        let total
        if (values.length === 1) {
          total = parseInt(values[0])
        } else {
          if (values.length > 1) {
            total = values?.reduce((a, b) => {
              return parseInt(a) + parseInt(b)
            })
          }
        }
        let temp
        let temp1
        if (errorState["nomineePercentCPF"]) {
          temp1 = errorState["nomineePercentCPF"]
        } else {
          temp1 = []
        }
        if (total !== 100) {
          const numberOfNominees = sectionState.sectionData["nomineePercentCPF"].length
          for (let i = 0; i < numberOfNominees; i++) {
            temp1[i] = "Total of Nominee Percentages must be 100"
          }
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              ["nomineePercentCPF"]: temp,
            }
          })
        } else {
          const numberOfNominees = sectionState.sectionData["nomineePercentCPF"].length
          for (let i = 0; i < numberOfNominees; i++) {
            temp1[i] = ""
          }
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              ["nomineePercentCPF"]: temp,
            }
          })
        }
      }

    }
  }

  //Code to call BI for product pages
  const saveApplicationAndCallBi = (formControlKey, value, previousSelectedValue) => {
    console.log(formControlKey, "dsfdfd")
    if (!showMainButtonFlexiEdgePlan) {
      return
    }
    let isValidSection = Object.keys(errorState).every(element => {
      if (element === "errorFromBI") {
        return true
      }
      if (Array.isArray(errorState[element])) {
        return errorState[element].every(subElement => {
          return subElement === ""
        })
      } else {
        if (element === formControlKey && value) {
          return true
        } else {
          return errorState[element] === ""
        }

      }
    })
    if (!isValidSection) {
      return
    }
    if (callBiKeyJson["keysTOCallOn"][sections[currentSectionIndex].sectionId] &&
      callBiKeyJson["keysTOCallOn"][sections[currentSectionIndex].sectionId].includes(formControlKey)) {
      let sectionStateToPass = sectionState
      sectionStateToPass.sectionData[formControlKey] = value
      if (!sectionStateToPass.sectionId) {
        sectionStateToPass.sectionId = sections[currentSectionIndex].sectionId
      }
      let pageData = pageState.pageData.filter(
        element => element.sectionId !== sectionState.sectionId
      )
      let journeyData = journeyState.journeyData.filter(
        element =>
          element.pageId !== props.pages[props.currentPageIndex].pageId
      )
      setPageState(prev => {
        return {
          ...prev,
          pageData: [...pageData, sectionStateToPass], // adding new section
        }
      })

      let LoadPaylod = [
        ...journeyData,
        {
          pageId: props.pages[props.currentPageIndex].pageId,
          pageData: [...pageData, sectionStateToPass],
        },
      ]
      console.log(LoadPaylod, "loadPayload")
      if (formControlKey === "CPCustomizePlanPremiumPaymentTerm") {
        setJourneyState(prev => {
          return ({
            ...prev,
            paymentFrequency: sectionState.sectionData["CPCustomizePlanPaymentFrequency"]
          })
        })
      }
      else if (formControlKey === "iSelect360CPCustomizePlanPremiumPaymentTerm") {
        setJourneyState(prev => {
          return ({
            ...prev,
            paymentFrequency: sectionState.sectionData["iSelect360CPCustomizePlanPaymentFrequency"]
          })
        })
      }
      if (formControlKey === "CPCustomizePlanPaymentFrequency" || formControlKey === "iSelect360CPCustomizePlanPaymentFrequency") {
        setJourneyState(prev => {
          return ({
            ...prev,
            paymentFrequency: value
          })
        })
      }
      if (formControlKey === "gstWaiverInd") {
        setJourneyState(prev => {
          return ({
            ...prev,
            gstWaiverInd: value ?? "N"
          })
        })
      }

      //console.log(firstLoadPaylod)
      let sendPayload = {
        applicationData: LoadPaylod,
        journeyData: {
          _id: journeyState.journeyId,
          // lastPage: getLastPageAndLastSection(props.currentPageIndex, currentSectionIndex, sections.length).lastPage,
          // lastSection: getLastPageAndLastSection(props.currentPageIndex, currentSectionIndex, sections.length).lastSection,
          lastPageCode: props.pageId,
          lastSectionCode: sections[currentSectionIndex].sectionId,
          journeyCode: findCurrentJourneyCode(props.pageId, sections[currentSectionIndex].sectionId),
          applicationNo: journeyState.applicationNo,
          illustrationNumber: journeyState.illustrationNumber,
          proposalEntryId: journeyState.proposalEntryId,
          planOption: journeyState.planOption,
          journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
          premium: journeyState.premium,
          channel: journeyState.channel,
          paymentFrequency: journeyState.paymentFrequency
        },
      }
      let toCallBi
      if (sections[currentSectionIndex].sectionId === "CPSpouseCoverDetails"
        || sections[currentSectionIndex].sectionId === "CPOptionInBuiltCoversSection"
        || sections[currentSectionIndex].sectionId === "iSelect360CPOptionalInBuilt"
        || sections[currentSectionIndex].sectionId === "iSelect360CPSpouseCoverDetails"
        || sections[currentSectionIndex].sectionId === "sectionFlexiEdgeCustomizeYourPlan"
        || sections[currentSectionIndex].sectionId === "CFSectionInvestmentDetails") {
        console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa", sections[currentSectionIndex].sectionId);
        let keysToCheck = callBiKeyJson["keysToCheck"][sections[currentSectionIndex].sectionId][formControlKey]
        console.log(keysToCheck, "keysToCheck")
        if (Array.isArray(keysToCheck)) {
          toCallBi = keysToCheck?.every(key => {
            if (!sectionStateToPass.sectionData[key]) {
              return false
            } else {
              return sectionStateToPass.sectionData[key] !== ""
            }
          })
        } else {
          console.log("previousSelectedValue", previousSelectedValue)
          if (previousSelectedValue || value) {
            if (value) {
              toCallBi = keysToCheck?.[value]?.every(key => {
                if (!sectionStateToPass.sectionData[key]) {
                  return false
                } else {
                  return sectionStateToPass.sectionData[key] !== ""
                }
              })
            } else {
              toCallBi = keysToCheck?.[previousSelectedValue]?.every(key => {
                if (!sectionStateToPass.sectionData[key]) {
                  return false
                } else {
                  return sectionStateToPass.sectionData[key] !== ""
                }
              })
            }

          } else {
            toCallBi = true
          }
        }
      } else {
        toCallBi = true
      }
      console.log(toCallBi, "toCallBi")
      if (toCallBi) {
        saveApplication(sendPayload).then(res => {
          // console.log(res)
          let payload = {
            journeyId: journeyState.journeyId
          }
          generateBI(payload).then(res => {
            console.log(res, "eefe")
            if (res.data.BIJson) {
              console.log("inside if")
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionData: {
                    ...sectionState.sectionData,
                    sumAssured: JSON.parse(res.data.BIJson)[0].SA ? JSON.parse(res.data.BIJson)[0].SA.toFixed(2) : ''
                  }
                }
              })
              setJourneyState(prev => {
                return ({
                  ...prev,
                  premium: ((journeyState.journeyIdFromStrapi === "FlexiEdgeJourney" ? Math.round(JSON.parse(res.data.BIJson)?.[0].MODAL_PREM) : (res?.data?.finalKeys?.PREMIUM)) || 0),
                })
              })
              setErrorState(prev => {
                return {
                  ...prev,
                  ["errorFromBI"]: "",
                }
              })
            } else {
              if (res.data.InputValidationStatus && res.data.InputValidationStatus[0]?.ErrorMessage) {
                let str = res.data.InputValidationStatus[0]?.ErrorMessage.map(el => el.value).join(',')
                setErrorState(prev => {
                  return {
                    ...prev,
                    ["errorFromBI"]: str,
                  }
                })
              } else {
                setErrorState(prev => {
                  return {
                    ...prev,
                    ["errorFromBI"]: res.data.Message,
                  }
                })
              }
            }
          })
        })
          .catch(err => {
            console.log("error in save application of save application and call BI function")
          })
      }
    }
  }

  const fullNameConverter = (firstName, middleName, lastName) => {
    let fullName
    if(firstName && middleName && lastName){
      return fullName = firstName + " " + middleName + " " + lastName
    }else if(firstName && lastName){
      return fullName = firstName + " " + lastName
    }else if(firstName &&  middleName){
      return fullName = firstName + " " + middleName
    }else if(firstName){
      return fullName = firstName
    }else{
      return ""
    }
  }

  /*Helper FUnction Ends*/

  //Code to handlePrevious Button Click
  const handlePreviousClick = () => {
    //this function runs on previous button click
    setShowError(false)
    setErrorState({})
    setCallBi(true)

    try {
      const payload = {
        journeyId: journeyState.journeyId, 
        buttonClicked:  "Previous", 
      };
      updateUserTrackerDetails(payload)
        .then((response) => {
          if (response?.status) {
            console.log("UserTracker updated successfully:", response.message);
          } else {
            console.error("Error in updating UserTracker:", response?.message);
          }
        })
        .catch((error) => {
          console.error("Error in updateUserTrackerDetails API call:", error);
        })
    } catch (error) {
      console.error("Error in handlePrevious:", error);
    }

    let keysToRemoveFromConditionState = {}
    if (sectionState.sectionId === "CPOptionInBuiltCoversSection" || sectionState.sectionId === "iSelect360CPOptionalInBuilt" || sectionState.sectionId === "SectionPension4lifePrimaryAnnuitantPersonalDetail"
    || sectionState.sectionId === "SectionPension4lifePrimaryAnnuitantCommunicationDetails" || sectionState.sectionId === "SectionPension4lifePrimaryAnnuitantOccupationDetails"
    || sectionState.sectionId === "SectionPension4lifeNomineeCommunicationDetails" || sectionState.sectionId === "SectionPension4lifeAppointeeCommunicationDetails" || sectionState.sectionId === "SectionPension4LifeProposerPersonalDetail"
    || sectionState.sectionId === "SectionPension4LifeProposerCommunication" || sectionState.sectionId === "SectionPension4LifeProposerOccupation") {
      Object.keys(sectionState.sectionData).forEach(key => {
        keysToRemoveFromConditionState[`${pageState.pageId}.${sectionState.sectionId}.${key}`] = ""
      })
    }
    console.log(keysToRemoveFromConditionState, 'erefrrgrg')

    //handeling section movement
    if (currentSectionIndex <= 0) {
      // condition to move to previous page

      if (props.currentPageIndex - 1 >= 0) {
        let foundPage = journeyState.journeyData.find(
          element => element.pageId === pageState.pageId
        )
        //console.log(foundPage, "foundPage")
        if (foundPage) {
          let newJourneyData = journeyState.journeyData.filter(
            element => element.pageId !== foundPage.pageId
          )
          setJourneyState(prev => {
            return {
              ...prev,
              journeyData: newJourneyData,
            }
          })
          foundPage = []
        }

        //to add current page to journey context
        setJourneyState(prev => {
          return {
            ...prev,
            journeyData: [...prev.journeyData, pageState],
          }
        })
        props.setCurrentPageIndex(prev => prev - 1) // to change page
        setCurrentSectionIndex(
          props.pages[props.currentPageIndex - 1].sections.length - 1
        ) // to render last section of previous page

        //picking previous page data from journey context
        journeyState.journeyData.map((element, index) => {
          if (
            element.pageId === props.pages[props.currentPageIndex - 1].pageId
          ) {
            setPageState(prev => {
              return {
                ...prev,
                pageId: element.pageId,
                pageData: element.pageData,
              }
            })
          } // picking last section of previous page
          element.pageData.map((section, index) => {
            if (
              section.sectionId ===
              props.pages[props.currentPageIndex - 1].sections[
                props.pages[props.currentPageIndex - 1].sections.length - 1
              ].sectionId
            ) {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionId: section.sectionId,
                  sectionData: section.sectionData,
                }
              })
            }
          })
        })
      }
    } else {
      // condition of same page
      setCurrentSectionIndex(prev => prev - 1) // this moves to previous section on same page
      setSectionState({
        sectionId: null,
        sectionFirstPass: null,
        sectionData: {},
      })

      //handeling context change
      if (pageState.pageId === props.pageId) {
        pageState.pageData.map((element, index) => {
          if (
            element.sectionId === sections[currentSectionIndex - 1]?.sectionId // setting section context from page context
          ) {
            setSectionState(prev => {
              return {
                ...prev,
                sectionId: element.sectionId,
                sectionData: element.sectionData,
              }
            })
          }
        })
      }
      console.log(sectionState, "sectionState previous")
      console.log(pageState, "pageState previous")
      console.log(journeyState, "journeyState previous")
    }
    setConditionState(prev => {
      return {
        ...prev,
        ...keysToRemoveFromConditionState
      }
    })
    keysToRemoveFromConditionState = {}

    setJourneyState(prev => {
      return {
        ...prev,
        lastPage: props.currentPageIndex,
        lastSection: currentSectionIndex,
        lastPageCode: props.pageId,
        lastSectionCode: sections[currentSectionIndex]?.sectionId,
        journeyCode: findCurrentJourneyCode(props.pageId, sections[currentSectionIndex]?.sectionId)
      }
    })
    //console.log(journeyState, "agete jkdcehbce")
  }
  //Code to Handle Submit Button Click
  const handleSubmit = async () => {
    console.log(conditionState, "condition state")
    console.log(journeyState, "journey state")
    // errorToastr('validation error')
    console.log(errorState, "inpage")
    // SectionGOPAPersonelDetails
    if (sections[currentSectionIndex].sectionId === "SectionFlexiEdgeCalculatePremiumPersonalDetails" || sections[currentSectionIndex].sectionId === "CFSectionTitaniumPersonelDetails" || sections[currentSectionIndex].sectionId === "SectionGuaranteedSavingsPersonelDetails" || sections[currentSectionIndex].sectionId === "SectionGOPAPersonelDetails" || sections[currentSectionIndex].sectionId === "SectionGuaranteedIncomeAdvantagePersonelDetails" || sections[currentSectionIndex].sectionId === "SectionInsureSmartPersonelDetails" || sections[currentSectionIndex].sectionId === "SectionMoneyBackPersonalDetails" || sections[currentSectionIndex].sectionId === "SectionJeevanNiveshCalculatePremiumPersonalDetails" || sections[currentSectionIndex].sectionId === "SectionSmartJuniorPersonelDetails") {
      if (sections[currentSectionIndex].sectionId === "SectionGuaranteedSavingsPersonelDetails" || sections[currentSectionIndex].sectionId === "SectionGOPAPersonelDetails" || sections[currentSectionIndex].sectionId === "SectionGuaranteedIncomeAdvantagePersonelDetails" || sections[currentSectionIndex].sectionId === "SectionInsureSmartPersonelDetails" || sections[currentSectionIndex].sectionId === "SectionMoneyBackPersonalDetails" || sections[currentSectionIndex].sectionId === "SectionJeevanNiveshCalculatePremiumPersonalDetails" || sections[currentSectionIndex].sectionId === "SectionSmartJuniorPersonelDetails") {
        let age = getAge(sectionState.sectionData.GOPAdob)
        if ((sectionState.sectionData.GOPAslifetobeAssuredandProposer === 'Y') && age < 18) {
          setErrorState(prev => {
            return {
              ...prev,
              ['GOPAdob']: "Please select proposer because LA is minor"
            }
          })
          errorToastr('Please select proposer because LA is minor')
          return
        } else {
          if (!sectionState.sectionData?.['GOPAdob']) {
            setErrorState(prev => {
              return {
                ...prev,
                ['GOPAdob']: "Please enter Date of Birth"
              }
            })
          } else {
            setErrorState(prev => {
              return {
                ...prev,
                ['GOPAdob']: ""
              }
            })
          }
        }
      } else {
        let age = getAge(sectionState.sectionData.dateOfBirth)
        if ((sectionState.sectionData.islifetobeAssuredandProposer === 'Y' || sectionState.sectionData.CFislifetobeAssuredandProposer === 'Y') && age < 18) {
          setErrorState(prev => {
            return {
              ...prev,
              ['dateOfBirth']: "Please select proposer because LA is minor"
            }
          })
          errorToastr('Please select proposer because LA is minor')
          return
        } else {
          if (!sectionState.sectionData?.['dateOfBirth']) {
            setErrorState(prev => {
              return {
                ...prev,
                ['dateOfBirth']: "Please enter Date of Birth"
              }
            })
          } else {
            setErrorState(prev => {
              return {
                ...prev,
                ['dateOfBirth']: ""
              }
            })
          }
        }
      }
    }
    if (["nomineeDetailsSection", "SectionFlexiEdgeFillProposalNomineeDetails"].includes(sections[currentSectionIndex].sectionId)) {
      checkNomineePercentage()
      const nomineeDobValues = sectionState.sectionData?.nomineeDob
      const nomineeDobArray = nomineeDobValues ? (Array.isArray(nomineeDobValues) ? nomineeDobValues : [nomineeDobValues]) : []
      const hasNomineeOver18 = nomineeDobArray.some(dob => {
        if (!dob) return false
        const currentDateInEpoch = Math.floor((new Date().getTime()) / 1000)
        const days = Math.ceil(((currentDateInEpoch - dob) / 60 / 60) / 24)
        return days > 6574
      })
      if (hasNomineeOver18 && (!sectionState.sectionData || !sectionState.sectionData["agreementStatement"])) {
        const consentErrorRaw = getValueFromJourney(
          journeyState.lookup?.required_error,
          "E199"
        )
        const consentError =
          consentErrorRaw && consentErrorRaw !== "NA"
            ? consentErrorRaw
            : "Please check Agreement Statement"
        errorToastr(consentError)
        setErrorState(prev => {
          return {
            ...prev,
            agreementStatement: consentError
          }
        })
        setShowError(true)
        return
      }
      setJourneyState(prev => {
        return {
          ...prev,
          nomineeDataSecond : {
            dob : sectionState?.sectionData?.["nomineeDob"]?.[0] || "",
            gender : sectionState?.sectionData?.["nomineeGender"]?.[0] || "",
            relationship : sectionState?.sectionData?.["nomineeRelationshipWithUser"]?.[0] || ""
          }
        }
      })
    }
    const firstPageContactStep = isFirstPageContactConsentStep(
      props.currentPageIndex,
      currentSectionIndex,
      props.showFirstSectionFields
    )
    const isCompleteFirstPageSection =
      props.currentPageIndex === 0 && currentSectionIndex === 0
    const privacyPolicyKey = CONTACT_CONSENT_CONFIG.keys.privacyPolicy
    const contactConsentValidation = isCompleteFirstPageSection
      ? validateFirstPageContactConsent(
          sectionState.sectionData,
          CONTACT_CONSENT_CONFIG.keys,
          CONTACT_CONSENT_CONFIG.proposerKeys,
          CONTACT_CONSENT_CONFIG
        )
      : { isValid: true, errors: {}, snapshot: null }

    if (isCompleteFirstPageSection && !contactConsentValidation.isValid) {
      setErrorState(prev => ({
        ...prev,
        ...contactConsentValidation.errors,
      }))
      setShowError(true)
      scrollToFirstError()
      return
    }
    if (
      isCompleteFirstPageSection &&
      contactConsentValidation.isValid &&
      errorState?.[privacyPolicyKey]
    ) {
      setErrorState(prev => ({
        ...prev,
        [privacyPolicyKey]: "",
      }))
    }

    let isValidSection = Object.keys(errorState).every(element => {
      if (
        isCompleteFirstPageSection &&
        element === privacyPolicyKey &&
        contactConsentValidation.snapshot &&
        !isConsentRequiredOnFirstPage(contactConsentValidation.snapshot)
      ) {
        return true
      }
      if (Array.isArray(errorState[element])) {
        return errorState[element].every(subElement => {
          return subElement === ""
        })
      } else {
        return errorState[element] === ""
      }
    })
    if (!isValidSection) {
      scrollToFirstError();
    }
    if (sections[currentSectionIndex].sectionId === "SectionFlexiEdgeCustomizeYourPlan" && !sectionState.sectionData['sumAssured']) {
      console.log("getting error in BI");
      return
    }
    // For BI error Show
    if (props.currentPageIndex === 0) {
      if (!isValidSection) {
        if (errorState["errorFromBI"]) {
          errorToastr(errorState["errorFromBI"])
          setShowError(true)
          console.log("For BI error Show")
          return
        }
      }
    }
    // if (props.currentPageIndex === 2) {
    //   if (!isValidSection) {
    //     if (errorState["familyMemberDetails"]) {
    //       Object.keys(errorState["familyMemberDetails"]).every(element => {
    //         if (errorState["familyMemberDetails"][element]) {
    //           errorToastr(errorState["familyMemberDetails"][element])
    //           setShowError(true)
    //           return
    //         }
    //       })
    //     }
    //   }
    // }
    if (journeyState.journeyIdFromStrapi === "GuaranteedSavingJourney" && props.pages[props.currentPageIndex].pageId === "PageGuaranteedSavingCalculatePremium" && sections[currentSectionIndex].sectionId === "SectionGuaranteedSavingInvestmentDetails") {
      if (!sectionState.sectionData["sumAssured"] || !sectionState.sectionData["GspAddition"] || !sectionState.sectionData["totalAmount"]) {
        errorToastr("Please calculate the benefit illustration before proceeding")
        return
      }
    }

    if (isValidSection) {
      const isFirstPageLastSection = props.currentPageIndex === 0 && currentSectionIndex >= sections.length - 1
      if (
        isFirstPageLastSection &&
        isEquitasChannel(journeyState.channel) &&
        journeyState.journeyId &&
        !firstPageDedupeTriggeredRef.current
      ) {
        const dedupePayload = {
          journeyId: journeyState.journeyId
        }
        dedupeCall(dedupePayload).catch(error => {
          console.error("Error in dedupeCall:", error)
        })

        if (getIsLaAndProposerDifferent()) {
          dedupeCallProposer(dedupePayload).catch(error => {
            console.error("Error in dedupeCallProposer:", error)
          })
        }
        firstPageDedupeTriggeredRef.current = true
      }

      if (props.currentPageIndex === 0 && currentSectionIndex === 0 && (props.showFirstSectionFields === false)) {
        props.setShowFirstSectionFields(true)
        setShowError(false)
        const isPensionJourney = ["pension4LifeJourney", "smartGuaranteedPensionJourney"].includes(
          journeyState.journeyIdFromStrapi
        )
        const privacyPolicyGroupId = isPensionJourney
          ? CONTACT_CONSENT_CONFIG.keys.privacyPolicy
          : "privacypolicy-MD-12-order-21"
        const privacyPolicyFormKey = isPensionJourney
          ? CONTACT_CONSENT_CONFIG.keys.privacyPolicy
          : "privacyPolicy"
        if (sectionState?.sectionData?.[privacyPolicyFormKey]) {

          let temp = journeyState.journeySteps
          const tempComponentGroupIndexToChange = temp.pages[props.currentPageIndex].sections[currentSectionIndex].component_groups.findIndex(element => element.componentId === privacyPolicyGroupId)
          const tempComponentIndex = temp.pages[props.currentPageIndex].sections[currentSectionIndex].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === privacyPolicyFormKey)
          temp.pages[props.currentPageIndex].sections[currentSectionIndex].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndex]["display"] = false;
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        } else {
          let temp = journeyState.journeySteps
          const pageId = temp.pages[props.currentPageIndex].pageId
          const sectionId = temp.pages[props.currentPageIndex].sections[currentSectionIndex].sectionId
          const tempComponentGroupIndexToChange = temp.pages[props.currentPageIndex].sections[currentSectionIndex].component_groups.findIndex(element => element.componentId === privacyPolicyGroupId)
          if (tempComponentGroupIndexToChange >= 0) {
            const tempComponentIndex = temp.pages[props.currentPageIndex].sections[currentSectionIndex].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === privacyPolicyFormKey)
            if (tempComponentIndex >= 0) {
              temp.pages[props.currentPageIndex].sections[currentSectionIndex].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndex].display = true
            }
          }
          moveComponentGroupToLast(temp, pageId, sectionId, privacyPolicyGroupId)
          setJourneyState(prev => ({
            ...prev,
            journeySteps: temp
          }))
        }
        async function applicationNumberGeneration() {
          let anurConfigChannels=[];
            try{
              const res=await getConfigByType({ type: "anur-config" })
              if (res?.data[0]?.config?.products?.hasOwnProperty(journeyState?.journeyIdFromStrapi)) {
                anurConfigChannels = res?.data[0]?.config?.products?.[journeyState?.journeyIdFromStrapi]?.channels || [];
                anurConfigChannels = anurConfigChannels.map(c => c.toUpperCase());
              }

            }
             catch(error){
              console.error(error)
              errorToastr(error?.response?.data?.message || error.message)
            }
          let payloadForApplicationNumber = {
            planCode: journeyState.planOption,
            channelType: "HSBC",
            userId: "ONLINE",
            source: "I",
          }
          let rmLedJourneyIndVal = journeyState.channel !== "A" ? "02" : journeyState.agentDetails.rmLedJourneyInd
          let rmLedFNAIndVal = journeyState.channel === "A" 
                                ? 
                                  (journeyState.rmLedJourney === "Y" ) 
                                  ? "N" 
                                  : "Y"  
                                : "N"
          if (journeyState?.fnaData?.FNASOURCE == "rm") {
            rmLedJourneyIndVal = '01'
          }
          let payloadForSaveJounrey = {
            basicDetails: {
              applicationNumber: "",
              journeyEncrypt: true,
              emailID: sectionState.sectionData.email,
              mobileNo: sectionState.sectionData.contactNumber,
              countryCode: sectionState.sectionData.contactCountryCode,
              channel: journeyState.channel,
              planCode: journeyState.planOption,
              planName: journeyState.planOption,
              journey: "1",
              illustrationNumber: "",
              proposalEntryId: "",
              fnaDetails: {
                FNAID: journeyState?.fnaData?.FNAID,
                PROPOSERFULLNAME: journeyState?.fnaData?.PROPOSERFULLNAME,
                BIRTHDATE: journeyState?.fnaData?.BIRTHDATE,
                PHONENUMBER: journeyState?.fnaData?.PHONENUMBER,
                EMAILID: journeyState?.fnaData?.EMAILID,
                ANNUALINCOME: journeyState?.fnaData?.ANNUALINCOME,
                ANNUALEXPENSES: journeyState?.fnaData?.ANNUALEXPENSES,
                ANNUALDISPOSABLRINCOME: journeyState?.fnaData?.ANNUALDISPOSABLRINCOME,
                EXISTINGLIFECOVER: journeyState?.fnaData?.EXISTINGLIFECOVER,
                LIFECOVERREQUIRED: journeyState?.fnaData?.LIFECOVERREQUIRED,
                GOALTOACHIEVE: journeyState?.fnaData?.GOALTOACHIEVE,
                TIMEHORIZON: journeyState?.fnaData?.TIMEHORIZON,
                CAPITALPROTECTION: journeyState?.fnaData?.CAPITALPROTECTION,
                PREFERREDPLAN: journeyState?.fnaData?.PREFERREDPLAN,
                PROPOSALENTRYID: journeyState?.fnaData?.PROPOSALENTRYID,
                CREATEDATE: journeyState?.fnaData?.CREATEDATE,
                FNAFLAG: journeyState?.fnaData?.FNAFLAG

              },
              videoVcApplicable:anurConfigChannels.includes(journeyState?.channel?.toUpperCase())?"Y":"N"
            },
            agentDetails: {
              eSPCode: journeyState.eSPCode,
              subChannel: journeyState.subChannel,
              ...journeyState.agentDetails,
              rmLedJourneyInd: rmLedJourneyIndVal,
              rmLedFNAInd: rmLedFNAIndVal
            },

            lastSection: 0,
            lastPage: 0,
            lastPageCode: "calculatePremiumPage",
            lastSectionCode: "CPPersonalDetailsSection",
            journeyCode: "J1_001",
          }
          let firstLoadPaylod = [
            {
              pageId: props.pages[props.currentPageIndex].pageId,
              pageData: [sectionState],
            },
          ]
          let collectionToBeMapped
          if(props?.canaraPosData){
            collectionToBeMapped = {
              fnaId: props?.canaraPosData?.canaraPosData[0]?.fnaData?._id,
              canaraPosId: props?.canaraPosData?.canaraPosData[1]?.canaraPosData?._id
            }
          }
          let saveApplicationPayload = {
            sendResponseData: true,
            applicationData: firstLoadPaylod,
            journeyData: {
              _id: "",
              lastPage: 0,
              lastSection: 0,
              lastPageCode: props.pageId,
              lastSectionCode: sections[currentSectionIndex].sectionId,
              journeyCode: "J1_001",
              applicationNo: "",
              illustrationNumber: "",
              planOption: journeyState.planOption,
              journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
              proposalEntryId: "",
              channel: journeyState.channel,
              premium: journeyState.premium ? journeyState.premium : 0,
              journeyType: journeyState?.journeyType,
              hsbcJourneyID: journeyState?.hsbcJourneyID,
              collectionToBeMapped: collectionToBeMapped
            },
          }
          let finalPayloadForApplicationNumberGeneration = {
            payloadForApplicationNumber: payloadForApplicationNumber,
            payloadForSaveJounrey: payloadForSaveJounrey,
            saveApplicationPayload: saveApplicationPayload
          }
          try {
            console.log(journeyState);
            if (journeyState?.applicationNo) {
              let sendPayload = {
                applicationData: firstLoadPaylod,
                journeyData: {
                  _id: journeyState.journeyId,
                  lastPage: getLastPageAndLastSection(props.currentPageIndex, currentSectionIndex, sections.length).lastPage,
                  lastSection: getLastPageAndLastSection(props.currentPageIndex, currentSectionIndex, sections.length).lastSection,
                  lastPageCode: props.pageId,
                  lastSectionCode: sections[currentSectionIndex].sectionId,
                  journeyCode: findCurrentJourneyCode(props.pageId, sections[currentSectionIndex].sectionId),
                  applicationNo: journeyState.applicationNo,
                  illustrationNumber: journeyState.illustrationNumber,
                  planOption: journeyState.planOption,
                  journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
                  proposalEntryId: journeyState.proposalEntryId,
                  premium: journeyState.premium,
                  channel: journeyState.channel,
                },
              }
              console.log(sendPayload);
              let saveApplicationResponse = await saveApplication(sendPayload)
              console.log(saveApplicationResponse);
            } else {
              let applicationNumberResponse = await saveApplicationDetailsOverall(finalPayloadForApplicationNumberGeneration)
              console.log(applicationNumberResponse.alljounreyData.basicDetails.applicationNumber, "applicationNumberResponse")
              setJourneyState(prev => {
                return {
                  ...prev,
                  proposalEntryId: applicationNumberResponse.alljounreyData.basicDetails.proposalEntryId,
                  applicationNo: applicationNumberResponse.alljounreyData.basicDetails.applicationNumber,
                  illustrationNumber: applicationNumberResponse.alljounreyData.basicDetails.illustrationNumber,
                  journeyId: applicationNumberResponse.alljounreyData._id,
                }
              })
              fetchDetailsAndSetCookie({
                journeyIdFromStrapi : journeyState.journeyIdFromStrapi,
                journeyId : applicationNumberResponse.alljounreyData._id,
                channel : journeyState.channel
              })
              .then((res) => {
                setCookiesFromBackend(res?.cookies)
              })
            }
          } catch (err) {
            console.log(err)
          }
        }
        applicationNumberGeneration()
        return
      }
      setFirstPassForPremiumPaymentBicall(true)
      setFirstPageAutoFillApiCall(true)
      setErrorState({})
      setShowError(false)
      // this function runs on submit button click
      //handeling section movement
      if (currentSectionIndex >= sections.length - 1) {
        console.log("inside if")
        // condition to move to next page

        /*to remove duplicate page state */
        let foundSection = pageState.pageData.find(
          //to prevent duplicate section
          element => element.sectionId === sectionState.sectionId
        )
        //console.log(foundSection, "foundSection")

        if (foundSection) {
          // removing the old section to add new section
          let newPageData = pageState.pageData.filter(
            element => element.sectionId !== foundSection.sectionId
          )
          setPageState(prev => {
            return {
              ...prev,
              pageData: [...newPageData, sectionState], //newPageData has all sections except founded section
            }
          })
          foundSection = {}
        } else {
          setPageState(prev => {
            return {
              ...prev,
              pageData: [...prev.pageData, sectionState], // adding new section
            }
          })
        }

        let foundPage = journeyState.journeyData.find(
          element => element.pageId === pageState.pageId
        )
        console.log(foundPage, "foundPage")
        if (foundPage) {
          let newJourneyData = journeyState.journeyData.filter(
            element => element.pageId !== foundPage.pageId
          )
          let pageData = pageState.pageData.filter(
            element => element.sectionId !== sectionState.sectionId
          )
          setJourneyState(prev => {
            return {
              ...prev,
              journeyData: [
                ...newJourneyData,
                {
                  pageId: props.pages[props.currentPageIndex].pageId,
                  pageData: [...pageData, sectionState],
                },
              ],
            }
          })
          foundPage = {}
        } else {
          let pageData = pageState.pageData.filter(
            element => element.sectionId !== sectionState.sectionId
          )

          setJourneyState(prev => {
            return {
              ...prev,
              journeyData: [
                ...prev.journeyData,
                {
                  pageId: props.pages[props.currentPageIndex].pageId,
                  pageData: [...pageData, sectionState],
                },
              ],
            }
          })
        }

        setPageState(prev => {
          return {
            ...prev,
            pageId: null,
            pageData: [],
          }
        })
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: null,
            sectionFirstPass: null,
            sectionData: {},
          }
        })
        /*to remove duplicate page state */

        journeyState.journeyData.map((element, index) => {
          // to get pageState if exists
          if (
            element.pageId === props.pages[props.currentPageIndex + 1].pageId
          ) {
            setPageState(prev => {
              return {
                ...prev,
                pageId: element.pageId,
                pageData: element.pageData,
              }
            })
            element.pageData.map((section, index) => {
              if (
                section.sectionId ===
                props.pages[props.currentPageIndex + 1].sections[0].sectionId
              ) {
                setSectionState(prev => {
                  return {
                    ...prev,
                    sectionId: section.sectionId,
                    sectionData: section.sectionData,
                  }
                })
              }
            })
          }
        })

        if (props.currentPageIndex < props.pages.length - 1) {
          // edge case condition for last page
          props.setCurrentPageIndex(prev => prev + 1)
          setCurrentSectionIndex(0)
          //console.log(journeyState, "journey state")
        }
      } else {
        // condition of same page

        //Handeling context change
        if (sectionState.sectionId !== null) {
          //console.log("is section ID null")
          if (pageState.pageId === props.pageId) {
            let foundSection = pageState.pageData.find(
              //to prevent duplicate section
              element => element.sectionId === sectionState.sectionId
            )
            //console.log(foundSection, "foundSection")

            if (foundSection) {
              // removing the old section to add new section
              const newPageData = pageState.pageData.filter(
                element => element.sectionId !== foundSection.sectionId
              )
              setPageState(prev => {
                return {
                  ...prev,
                  pageData: newPageData, //newPageData has all sections except founded section
                }
              })
              foundSection = {}
            }

            setPageState(prev => {
              return {
                ...prev,
                pageData: [...prev.pageData, sectionState], // adding new section
              }
            })
          } else {
            setPageState(prev => {
              // case of new page
              return {
                ...prev,
                pageId: props.pageId,
                pageData: [...prev.pageData, sectionState],
              }
            })
          }
        }

        setSectionState(prev => {
          // making section data empty to load new sectionData
          return {
            ...prev,
            sectionId: null,
            sectionFirstPass: null,
            sectionData: {},
          }
        })

        pageState.pageData.map((element, index) => {
          if (
            element.sectionId === sections[currentSectionIndex + 1].sectionId
          ) {
            //loading section state if already present
            setSectionState(prev => {
              return {
                ...prev,
                sectionId: element.sectionId,
                sectionData: element.sectionData,
              }
            })
          }
        })

        console.log(sectionState, "section state")
        console.log(pageState, "pageState")
        console.log(journeyState, "journey state else")
        console.log("setCurrentSectionIndex6");
        setCurrentSectionIndex(prev => prev + 1)
        props.sections[currentSectionIndex].class = "active"
      }

      // save application details
      setJourneyState(prev => {
        return {
          ...prev,
          lastPage: props.currentPageIndex,
          lastSection: currentSectionIndex,
          lastPageCode: props.pageId,
          lastSectionCode: sections[currentSectionIndex].sectionId,
          journeyCode: findCurrentJourneyCode(props.pageId, sections[currentSectionIndex].sectionId)
        }
      })
      //console.log(journeyState, "agete jkdcehbce")


      let pageData = pageState.pageData.filter(
        element => element.sectionId !== sectionState.sectionId
      )
      let journeyData = journeyState.journeyData.filter(
        element =>
          element.pageId !== props.pages[props.currentPageIndex].pageId
      )

      let LoadPaylod = [
        ...journeyData,
        {
          pageId: props.pages[props.currentPageIndex].pageId,
          pageData: [...pageData, sectionState],
        },
      ]

      //console.log(firstLoadPaylod)
      let sendPayload = {
        applicationData: LoadPaylod,
        journeyData: {
          _id: journeyState.journeyId,
          lastPage: getLastPageAndLastSection(props.currentPageIndex, currentSectionIndex, sections.length).lastPage,
          lastSection: getLastPageAndLastSection(props.currentPageIndex, currentSectionIndex, sections.length).lastSection,
          lastPageCode: props.pageId,
          lastSectionCode: sections[currentSectionIndex].sectionId,
          journeyCode: findCurrentJourneyCode(props.pageId, sections[currentSectionIndex].sectionId),
          applicationNo: journeyState.applicationNo,
          illustrationNumber: journeyState.illustrationNumber,
          planOption: journeyState.planOption,
          journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
          proposalEntryId: journeyState.proposalEntryId,
          premium: journeyState.premium,
          channel: journeyState.channel,
          sendCaseToCustomerFirstResume: journeyState?.sendCaseToCustomerFirstResume
        },
        posDashboardListingData:{
          sendCaseToCustomerFirstResume: journeyState?.sendCaseToCustomerFirstResume
        }
      }
      saveApplication(sendPayload).then(async res => {
        setCallBi(true);
        // if (sections[currentSectionIndex].sectionId === "residenceDetailsSection" || sections[currentSectionIndex].sectionId === "SectionPension4lifePrimaryAnnuitantCommunicationDetails") {
        //   const data = await checkDocuments({ _id: journeyState.journeyId });
        // }
        setSaveApplicationCounter(prev => prev + 1)
        //console.log(res)
      }).catch(error => {
        console.log("asdsadasd", errorState)
        if (currentSectionIndex === sections.length - 1) {
          if (props.currentPageIndex >= 0) {
            // let foundPage = journeyState.journeyData.find(
            //   element => element.pageId === props.pages[props.currentPageIndex - 1].pageId
            // )
            // if (foundPage) {
            setPageState({
              pageId: pageState.pageId,
              pageData: pageState.pageData
            })
            // let foundSection = foundPage.pageData.find(
            //   element => element.sectionId === props.pages[props.currentPageIndex -1].sections[sections.length -1].sectionId
            // )
            // if (foundSection) {
            setSectionState({
              sectionId: sectionState.sectionId,
              sectionData: sectionState.sectionData
            })
            // }
          }
          props.setCurrentPageIndex(prev => prev - 1)
          setCurrentSectionIndex(props.pages[props.currentPageIndex]?.sections.length - 1)
          setErrorState({})
        } else {
          // let foundSection = pageState.pageData.find(element => {
          //   console.log(element, "sdfdf", sectionState)
          //   return element.sectionId === sectionState.sectionId
          // })
          // if(foundSection){
          setSectionState({
            sectionId: sectionState.sectionId,
            sectionData: sectionState.sectionData
          })
          // }
          setCurrentSectionIndex(prev => prev - 1)
          setErrorState({})

        }
      })
      // .then(res => {
      //   if(currentSectionIndex >= sections.length - 1){
      //     if(props.currentPageIndex < props.pages.length - 1) {
      //       // edge case condition for last page
      //       props.setCurrentPageIndex(prev => prev + 1)
      //       setCurrentSectionIndex(0)
      //       //console.log(journeyState, "journey state")
      //     }
      //   }else{
      //     setCurrentSectionIndex(prev => prev + 1);
      //   }
      // })
    } else {
      if ((sections[currentSectionIndex].sectionId === "SectionCommonResidenceAndOccupation" && errorState["GOPApincode"] && errorState["GOPApincode"] === "This Pincode is not serviceable")
        || (sections[currentSectionIndex].sectionId === "proposerCommonResidenceAndOccupation" && errorState["proposerPincode"] && errorState["proposerPincode"] === "This Pincode is not serviceable")
      ) {
        errorToastr(`Thank You for choosing Canara HSBC Life Insurance Company Limited -${lookup?.['errorToaster']?.[journeyState.journeyIdFromStrapi]}. Basis your input this Plan is not available.`)
      }
      setShowError(true)
    }

    try { // for recaptcha v3 implementation
      if (journeyState.applicationNo){
        const token = await executeRecaptcha("submit_form");
        verifyCaptcha({
          token : token,
          applicationNumber : journeyState.applicationNo,
          sectionId : sectionState.sectionId,
          pageId : props.pages[props.currentPageIndex].pageId
        })
        .then(res => {
          console.info(res)
        })
        .catch(err => {
          console.info(err)
        })
      }
    }catch(err){
      console.info(err)
    }
  }


  const handleCalculatePension4Life = async () => {
    let isValidSection = Object.keys(errorState).every(element => {
      if (Array.isArray(errorState[element])) {
        return errorState[element].every(subElement => {
          return subElement === ""
        })
      } else {
        return errorState[element] === ""
      }
    })
    if (isValidSection) {
      if (pageState.pageId === props.pages[props.currentPageIndex].pageId) {
        let foundSection = pageState.pageData.find(
          element => element.sectionId === sectionState.sectionId
        )

        if (foundSection) {
          let newPageData = pageState.pageData.filter(
            element => element.sectionId !== foundSection.sectionId
          )
          setPageState(prev => {
            return {
              ...prev,
              pageData: newPageData, //newPageData has all sections except founded section
            }
          })
          foundSection = {}
        }

        setPageState(prev => {
          return {
            ...prev,
            pageData: [...prev.pageData, sectionState], // adding new section
          }
        })
      } else {
        setPageState(prev => {
          return {
            ...prev,
            pageId: props.pages[props.currentPageIndex].pageId,
            pageData: [...prev.pageData, sectionState],
          }
        })
      }

      let pageData = pageState.pageData.filter(
        element => element.sectionId !== sectionState.sectionId
      )
      let journeyData = journeyState.journeyData.filter(
        element => element.pageId !== props.pages[props.currentPageIndex].pageId
      )

      let LoadPaylod = [
        ...journeyData,
        {
          pageId: props.pages[props.currentPageIndex].pageId,
          pageData: [...pageData, sectionState],
        },
      ]

      let sendPayload = {
        applicationData: LoadPaylod,
        journeyData: {
          _id: journeyState.journeyId,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          applicationNo: journeyState.applicationNo,
          illustrationNumber: journeyState.illustrationNumber,
          planOption: journeyState.planOption,
          journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
          proposalEntryId: journeyState.proposalEntryId,
          lastPageCode: props.pageId,
          premium: journeyState.premium,
          lastSectionCode: sections[currentSectionIndex].sectionId,
        },
      }
      saveApplication(sendPayload).then(async res => {
        let payload = {
          journeyId: journeyState.journeyId,
        }
        const biApiData = await generateBI(payload)
        if (biApiData.data?.BIJson && (journeyState.journeyIdFromStrapi === "pension4LifeJourney" || journeyState.journeyIdFromStrapi === "smartGuaranteedPensionJourney")) {
          console.log(sectionState, "sections")
          let biJson = JSON.parse(biApiData.data?.BIJson)
          let premiumAmount = Math.floor(biJson[0]?.["MODAL_PREM_TAX"])
          setJourneyState(prev => {
            return ({
              ...prev,
              "pension4LifeKeys": {
                "premiumAmount": premiumAmount
              }
            })
          })
          props.setCurrentPageIndex(prev => prev + 1)
          setCurrentSectionIndex(0)

        }
      }).catch(err => {
        console.log(err, "err in saveApplication componentButton")
      })
    } else {
      setShowError(true)
    }
  }
  const handleJourneyProceedButton = async () => {
    if (sections[currentSectionIndex].proceedButtonFunctionToCall) {
      if (sections[currentSectionIndex].proceedButtonFunctionToCall === "handleCalculatePension4Life") {
        handleCalculatePension4Life()
      }
      else {
        return
      }
    } else {
      handleSubmit()
    }
  }

  // code of tab enter
  const handleEnterPrevious = (event) => {
    if (event?.key == 'Enter') {
      handlePreviousClick();
    }
  }

  if (props?.pageId === "PageSmartGuaranteedPensionCalculatePremium" && props?.paymentData?.payloadJson?.module === "payment" && showLoader) {
    return null
  }
  return (
    <>
      <style>
        {`
            .journey-buttons{
              clear: both;
              margin: -20px 0px 0px 0px;
              padding: 0px;
              display: inline-block;
              width: 100%;
              text-align: center;
            }
            .middle{
              flex: 0 0 auto;
              width: 100%;
            }
            @media (max-width: 767px){
              .journey-buttons {
                padding: 15px 0px !important;
                margin: -20px 0px 0px 0px;
              }
            }
            // button{
            //   color: white;
            //   background-color: var(--lumiq-tertiary);
            //   height: 50px;
            //   width: 80px;
            //   margin-right: 20px;
            //   border-radius: 10px;
            //   border: none;
            // }  
          `}
      </style>
      {/* body-section */}
      {sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "provide-your-consent" ? (
        <ProvideYourConsent
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "provide-your-consent-proposer" ? (
        <ProvideYourConsentProposer
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "ekyc" ? (
        <Ekyc
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "ekycProposer" ? (
        <EkycProposer
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "ckyc" ? (
        <Ckyc
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "ckycProposer" ? (
        <CkycProposer
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
        ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "smartGuaranteedPensionBI" ? (
        <BISmartGuaranteedPension
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "make-Payment" ? (
        <Payment
          channel={journeyState.channel}
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "UploadDocuments" ? (
        <UploadDocuments
          channel={journeyState.channel} 
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "successful-transaction" ? (
        <SuccessfulTransactions
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          pages={props.pages}
          callBi={callBi}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "unsuccessful-transaction" ? (
        <UnsuccessfulTransaction
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "pending-transaction" ? (
        <PendingTransaction
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
      ) : sections?.[currentSectionIndex] &&
      sections[currentSectionIndex].sectionId === "pending-transaction-basba" ? (
      <PendingTransactionBasba
        currentPageIndex={props.currentPageIndex}
        currentSectionIndex={currentSectionIndex}
        setCurrentSectionIndex={setCurrentSectionIndex}
        setCurrentPageIndex={props.setCurrentPageIndex}
        sections={sections}
        pageId={props.pageId}
        showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
        setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
      />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "eNach-physicalMandate" ? (
        <ENachPhysicalMandate
          channel={journeyState.channel}
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "declaration" ? (
        <Declaration
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "salesConfidentialReport" ? (
        <SalesConfidentialReport
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pages={props.pages}
          pageId={props.pageId}
        />  
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "application-submission" ? (
        <Submission
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
        ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "SectionPension4LifeViewBenefitIllustration" ? (
        <BIPension4Life
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
        ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "review-details-pension4Life" ? (
        <ReviewDetailsPension4Life
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
        />
     
        ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "ThankYou" ? (
        <ThankYou
        currentPageIndex={props.currentPageIndex}
        currentSectionIndex={currentSectionIndex}
        setCurrentSectionIndex={setCurrentSectionIndex}
        setCurrentPageIndex={props.setCurrentPageIndex}
        sections={sections}
        pageId={props.pageId}
        />
      ) : (
        <>
          <div className="landing-page1-design">
            <div className="container">
              <div className="row">
                {/* left-side */}

                <Section
                  section={sections?.[currentSectionIndex]}
                  currentSectionIndex={currentSectionIndex}
                  setCurrentSectionIndex={setCurrentSectionIndex}
                  currentPageIndex={props.currentPageIndex}
                  setCurrentPageIndex={props.setCurrentPageIndex}
                  pageId={props.pageId}
                  showError={showError}
                  setShowError={setShowError}
                  pages={props.pages}
                  sections={sections}
                  sectionId={sections?.[currentSectionIndex]?.sectionId}
                  nvestFilterResult={nvestFilterResult}
                  saveApplicationAndCallBi={saveApplicationAndCallBi}
                  showFirstSectionFields={props.showFirstSectionFields}
                  firstPassForPremiumPaymentBicall={firstPassForPremiumPaymentBicall}
                  setFirstPassForPremiumPaymentBicall={setFirstPassForPremiumPaymentBicall}
                  showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
                  setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan}
                />
                {/* left-side */}

                {/* <!--right-side--> */}
                {
                  journeyState.journeySteps.showRideSideBar &&

                  <RightSideBar
                    sections={sections}
                    currentSectionIndex={currentSectionIndex}
                    setCurrentSectionIndex={setCurrentSectionIndex}     
                    showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
                    setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan}    
                    channelTypeforcolorChange = {journeyState.channel}
                  />
                }

                {/* <!--right-side--> */}
              </div>
            </div>
          </div>
          {showMainButtonFlexiEdgePlan && !sections?.[currentSectionIndex]?.notShowJourneyButtons &&
            <div className="container" >
              <div className="middle">
                <div className={`journey-buttons hidden-desktop-screen ${journeyState?.journeySteps?.showRideSideBar ? "w-75" : "w-100"}`}>
                  {/* {console.log("page indexing",props,props.currentPageIndex , currentSectionIndex )} */}
                  {!((props.currentPageIndex === 0 || props.pageId === "fillProposalForm" || props.pageId === "pageISelect360FillProposalForm" || props.pageId === "PageFlexiEdgeFillProposalForm" || props.pageId === "PagePension4lifeFillProposalForm") && currentSectionIndex === 0) && (
                    <div className="provider submit-btn cen" tabIndex="0"
                      onKeyPress={(e) => handleEnterPrevious(e)}
                    >
                      <a aria-hidden="true" onClick={handlePreviousClick}>{sections[currentSectionIndex]?.previousButtonName ? sections[currentSectionIndex]?.previousButtonName : "Previous"}</a>
                    </div>
                  )}
                  <input
                    type="submit"
                    className="provider previous-btn cen"
                    tabIndex="0"
                    style={{
                      color: "white",
                      padding: "14px 40px",
                      border: "none",
                    }}
                    onClick={handleJourneyProceedButton}
                    value={sections[currentSectionIndex]?.proceedButtonName ? sections[currentSectionIndex]?.proceedButtonName : "Proceed"}
                  />
                </div>
              </div>
            </div>
          }

          {/* <!--mobile view button--> */}
          {showMainButtonFlexiEdgePlan && !sections?.[currentSectionIndex]?.notShowJourneyButtons &&
            <div className="mobile-view-btn-Q1 pd-mobile-space-structure">
              <div className="iselect-mg-bottom">
                <div className="col-md-12">
                  <div className="but-center text-center">
                    {!(
                      (props.currentPageIndex === 0 || props.pageId === "fillProposalForm" || props.pageId === "pageISelect360FillProposalForm") && currentSectionIndex === 0
                    ) && (
                        <div className="submit-btn cen">
                          <a aria-hidden="true" onClick={handlePreviousClick}>{sections[currentSectionIndex]?.previousButtonName ? sections[currentSectionIndex]?.previousButtonName : "Previous"}</a>
                        </div>
                      )}
                    <input
                      type="submit"
                      className="previous-btn cen"
                      style={{
                        color: "white",
                        padding: "14px 40px",
                        border: "none",
                        marginLeft: "8px",
                      }}
                      onClick={handleJourneyProceedButton}
                      value={sections[currentSectionIndex]?.proceedButtonName ? sections[currentSectionIndex]?.proceedButtonName : "Proceed"}
                    />
                  </div>
                </div>
              </div>
            </div>
          }
          {/* <!--mobile view button-->   */}
          {/* body-section */}
        </>
      )}
    </>
  )
}

export default Page
